(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@sm360/widget-commons-core-services"), require("@sm360/widget-commons-general"), require("@sm360/widget-commons-forms"), require("lodash"), require("@sm360/widget-commons-vehicle"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define("financing", ["react", "@sm360/widget-commons-core-services", "@sm360/widget-commons-general", "@sm360/widget-commons-forms", "_", "@sm360/widget-commons-vehicle", "moment"], factory);
	else if(typeof exports === 'object')
		exports["financing"] = factory(require("react"), require("@sm360/widget-commons-core-services"), require("@sm360/widget-commons-general"), require("@sm360/widget-commons-forms"), require("lodash"), require("@sm360/widget-commons-vehicle"), require("moment"));
	else
		root["Financing"] = factory(root["React"], root["CommonsCoreServices"], root["CommonsGeneral"], root["CommonsForms"], root["_"], root["CommonsVehicle"], root["moment"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_core_services__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_forms__, __WEBPACK_EXTERNAL_MODULE_lodash__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_vehicle__, __WEBPACK_EXTERNAL_MODULE_moment__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../node_modules/@babel/runtime/helpers/esm/extends.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ "../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),

/***/ "../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/ConfigurationManager/ConfigurationManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _extends=Object.assign||function(a){for(var b,c=1;c<arguments.length;c++)for(var d in b=arguments[c],b)Object.prototype.hasOwnProperty.call(b,d)&&(a[d]=b[d]);return a},_createClass=function(){function a(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,'value'in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),_ravenJs=__webpack_require__("../../node_modules/raven-js/src/singleton.js"),_ravenJs2=_interopRequireDefault(_ravenJs),_lodash=__webpack_require__("lodash"),_config=__webpack_require__("./src/config/index.js"),_config2=_interopRequireDefault(_config),_logLevel=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/constants/logLevel.js"),_logLevel2=_interopRequireDefault(_logLevel),_logger=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/ConsoleLogger/logger.js"),_logger2=_interopRequireDefault(_logger);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError('Cannot call a class as a function')}var ConfigurationManager=function(){function a(b,c){_classCallCheck(this,a),this.console=_logger2.default;var d=_config2.default.sentry,e=d.default?d.default.sentry:d.sentry;this.sentryLevel=_logLevel2.default.DEBUG,this.consoleLevel=_logLevel2.default.DEBUG,this.loggerName=b||'',e&&e.url&&(this.configureSentry(e,b,c),this.setLogLevel(e))}return _createClass(a,[{key:'configureSentry',value:function configureSentry(a,b,c){if(a&&a.url){var d=_extends({},a,{logger:b||''});d.whitelistUrls&&(d.whitelistUrls=(0,_lodash.map)(d.whitelistUrls,function(a){return(0,_lodash.startsWith)(a,'^')?new RegExp(a):a})),_ravenJs2.default.config(a.url,d).install(),_ravenJs2.default.setExtraContext(c)}}},{key:'setLogLevel',value:function setLogLevel(a){var b=a.sentryLevel,c=a.consoleLevel;if(b&&_logLevel2.default[b])this.sentryLevel=_logLevel2.default[b.toUpperCase()];else throw new Error('Log level ['+b+'] is not supported');if(c&&_logLevel2.default[c])this.consoleLevel=_logLevel2.default[c.toUpperCase()];else throw new Error('Log level ['+c+'] is not supported')}}]),a}();exports.default=ConfigurationManager;
//# sourceMappingURL=ConfigurationManager.js.map

/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/ConsoleLogger/logger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var logger={};if('undefined'!=typeof console)logger=console;else if('undefined'!=typeof window&&'undefined'!=typeof window.console)logger=window.console;else{var noop=function(){};logger={debug:noop,error:noop,info:noop,log:noop,warn:noop,trace:noop}}var log=logger;exports.default=log;
//# sourceMappingURL=logger.js.map

/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/LoggerSentry/LoggerSentry.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createClass=function(){function a(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,'value'in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),_ravenJs=__webpack_require__("../../node_modules/raven-js/src/singleton.js"),_ravenJs2=_interopRequireDefault(_ravenJs),_logLevel=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/constants/logLevel.js"),_logLevel2=_interopRequireDefault(_logLevel),_ConfigurationManager2=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/ConfigurationManager/ConfigurationManager.js"),_ConfigurationManager3=_interopRequireDefault(_ConfigurationManager2);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(a,b){if(!a)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return b&&('object'==typeof b||'function'==typeof b)?b:a}function _inherits(a,b){if('function'!=typeof b&&null!==b)throw new TypeError('Super expression must either be null or a function, not '+typeof b);a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,enumerable:!1,writable:!0,configurable:!0}}),b&&(Object.setPrototypeOf?Object.setPrototypeOf(a,b):a.__proto__=b)}var LoggerSentry=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,(b.__proto__||Object.getPrototypeOf(b)).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:'sendToSentry',value:function sendToSentry(a,b,c,d){if(_ravenJs2.default.isSetup&&this.sentryLevel.level<=a.level)if(b)_ravenJs2.default.captureException(b,{message:c,level:a.name,extra:d||{}});else{var e={level:a.name,extra:d||{}};_ravenJs2.default.captureMessage(c,e)}}},{key:'error',value:function error(a,b,c){this.sendToSentry(_logLevel2.default.ERROR,b,a,c),this.consoleLevel.level<=_logLevel2.default.ERROR.level&&this.console.error('[ERROR]','"'+this.loggerName+'"',a||'',b||'')}},{key:'warning',value:function warning(a,b,c){this.sendToSentry(_logLevel2.default.WARNING,b,a,c),this.consoleLevel.level<=_logLevel2.default.WARNING.level&&this.console.warn('[WARNING]','"'+this.loggerName+'"',a||'',b||'')}},{key:'info',value:function info(a,b,c){this.sendToSentry(_logLevel2.default.INFO,b,a,c),this.consoleLevel.level<=_logLevel2.default.INFO.level&&this.console.info('[INFO]','"'+this.loggerName+'"',a||'',b||'')}},{key:'debug',value:function debug(a,b,c){this.sendToSentry(_logLevel2.default.DEBUG,b,a,c),this.consoleLevel.level<=_logLevel2.default.DEBUG.level&&this.console.log('[DEBUG]','"'+this.loggerName+'"',a||'',b||'')}}]),b}(_ConfigurationManager3.default);exports.default=LoggerSentry;
//# sourceMappingURL=LoggerSentry.js.map

/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/constants/logLevel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.default={DEBUG:{level:1,name:'debug'},INFO:{level:2,name:'info'},WARNING:{level:3,name:'warning'},ERROR:{level:4,name:'error'},NONE:{level:99,name:'none'}};
//# sourceMappingURL=logLevel.js.map

/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _LoggerSentry=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/LoggerSentry/LoggerSentry.js"),_LoggerSentry2=_interopRequireDefault(_LoggerSentry);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}exports.default=_LoggerSentry2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/axios/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../node_modules/axios/lib/axios.js");

/***/ }),

/***/ "../../node_modules/axios/lib/adapters/xhr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var settle = __webpack_require__("../../node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__("../../node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__("../../node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__("../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__("../../node_modules/axios/lib/core/createError.js");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("../../node_modules/axios/lib/helpers/btoa.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("../../node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var bind = __webpack_require__("../../node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__("../../node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("../../node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__("../../node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__("../../node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("../../node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/Cancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/CancelToken.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("../../node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/isCancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/Axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");
var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__("../../node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__("../../node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "../../node_modules/axios/lib/core/InterceptorManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "../../node_modules/axios/lib/core/createError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("../../node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/dispatchRequest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var transformData = __webpack_require__("../../node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__("../../node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__("../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__("../../node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/enhanceError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/settle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("../../node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/transformData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "../../node_modules/axios/lib/defaults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__("../../node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("../../node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("../../node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/axios/lib/helpers/bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/btoa.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/buildURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/combineURLs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/cookies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/normalizeHeaderName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/parseHeaders.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/spread.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("../../node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__("../../node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "../../node_modules/invariant/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ "../../node_modules/is-buffer/index.js":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "../../node_modules/lodash-es/_Symbol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("../../node_modules/lodash-es/_root.js");


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),

/***/ "../../node_modules/lodash-es/_baseGetTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("../../node_modules/lodash-es/_Symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__("../../node_modules/lodash-es/_getRawTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__("../../node_modules/lodash-es/_objectToString.js");




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),

/***/ "../../node_modules/lodash-es/_freeGlobal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/lodash-es/_getPrototype.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__("../../node_modules/lodash-es/_overArg.js");


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),

/***/ "../../node_modules/lodash-es/_getRawTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("../../node_modules/lodash-es/_Symbol.js");


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),

/***/ "../../node_modules/lodash-es/_objectToString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),

/***/ "../../node_modules/lodash-es/_overArg.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),

/***/ "../../node_modules/lodash-es/_root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("../../node_modules/lodash-es/_freeGlobal.js");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),

/***/ "../../node_modules/lodash-es/isObjectLike.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),

/***/ "../../node_modules/lodash-es/isPlainObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("../../node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__("../../node_modules/lodash-es/_getPrototype.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("../../node_modules/lodash-es/isObjectLike.js");




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),

/***/ "../../node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../../node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("../../node_modules/prop-types/lib/ReactPropTypesSecret.js");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "../../node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("../../node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "../../node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "../../node_modules/raven-js/src/configError.js":
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),

/***/ "../../node_modules/raven-js/src/console.js":
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__("../../node_modules/raven-js/src/utils.js");

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),

/***/ "../../node_modules/raven-js/src/raven.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__("../../node_modules/raven-js/vendor/TraceKit/tracekit.js");
var stringify = __webpack_require__("../../node_modules/raven-js/vendor/json-stringify-safe/stringify.js");
var md5 = __webpack_require__("../../node_modules/raven-js/vendor/md5/md5.js");
var RavenConfigError = __webpack_require__("../../node_modules/raven-js/src/configError.js");

var utils = __webpack_require__("../../node_modules/raven-js/src/utils.js");
var isErrorEvent = utils.isErrorEvent;
var isDOMError = utils.isDOMError;
var isDOMException = utils.isDOMException;
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__("../../node_modules/raven-js/src/console.js").wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.27.0',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = {};
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isDOMError(ex) || isDOMException(ex)) {
      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
      // then we just extract the name and message, as they don't provide anything else
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
      var message = ex.message ? name + ': ' + ex.message : name;

      return this.captureMessage(
        message,
        objectMerge(options, {
          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
          // but it's barely any overhead so we may at least try
          stacktrace: true,
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a DOMError/DOMException
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    // Always attempt to get stacktrace if message is empty.
    // It's the only way to provide any helpful information to the user.
    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = objectMerge(
      {
        eventId: this.lastEventId(),
        dsn: this._dsn,
        user: this._globalContext.user || {}
      },
      options
    );

    if (!options.eventId) {
      throw new RavenConfigError('Missing eventId');
    }

    if (!options.dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var encodedOptions = [];

    for (var key in options) {
      if (key === 'user') {
        var user = options.user;
        if (user.name) encodedOptions.push('name=' + encode(user.name));
        if (user.email) encodedOptions.push('email=' + encode(user.email));
      } else {
        encodedOptions.push(encode(key) + '=' + encode(options[key]));
      }
    }
    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: orig.name || '<anonymous>'}
              }
            },
            originalCallback
          );
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          target: global,
                          function: 'handleEvent',
                          handler: (fn && fn.name) || '<anonymous>'
                        }
                      }
                    },
                    fn.handleEvent
                  );
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(
                  {
                    mechanism: {
                      type: 'instrument',
                      data: {
                        target: global,
                        function: 'addEventListener',
                        handler: (fn && fn.name) || '<anonymous>'
                      }
                    }
                  },
                  fn,
                  before
                ),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(
              self.wrap(
                {
                  mechanism: {
                    type: 'instrument',
                    data: {
                      function: 'requestAnimationFrame',
                      handler: (orig && orig.name) || '<anonymous>'
                    }
                  }
                },
                cb
              )
            );
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
              }
            },
            orig
          );
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          function: 'onreadystatechange',
                          handler: (orig && orig.name) || '<anonymous>'
                        }
                      }
                    },
                    orig,
                    onreadystatechangeHandler
                  );
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      _window.history.pushState &&
      _window.history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function(stackInfo, options) {
    options = options || {};
    options.mechanism = options.mechanism || {
      type: 'onerror',
      handled: false
    };

    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo(stackInfo, options);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        transaction: fileurl
      },
      options
    );

    var ex = data.exception.values[0];
    if (ex.type == null && ex.value === '') {
      ex.value = 'Unrecoverable error caught';
    }

    // Move mechanism from options to exception interface
    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
    // too much
    if (!data.exception.mechanism && data.mechanism) {
      data.exception.mechanism = data.mechanism;
      delete data.mechanism;
    }

    data.exception.mechanism = objectMerge(
      {
        type: 'generic',
        handled: true
      },
      data.exception.mechanism || {}
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': _navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.transaction !== last.transaction // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raven-js/src/singleton.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__("../../node_modules/raven-js/src/raven.js");

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raven-js/src/utils.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__("../../node_modules/raven-js/vendor/json-stringify-safe/stringify.js");

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
      ? global
      : typeof self !== 'undefined'
        ? self
        : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
}

function isDOMError(value) {
  return Object.prototype.toString.call(value) === '[object DOMError]';
}

function isDOMException(value) {
  return Object.prototype.toString.call(value) === '[object DOMException]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMError() {
  try {
    new DOMError(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMException() {
  try {
    new DOMException(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if stacktrace is malformed
  if (frames1 === undefined || frames2 === undefined) return false;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isDOMError: isDOMError,
  isDOMException: isDOMException,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsDOMError: supportsDOMError,
  supportsDOMException: supportsDOMException,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raven-js/vendor/TraceKit/tracekit.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__("../../node_modules/raven-js/src/utils.js");

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';
  return document.location.href;
}

function getLocationOrigin() {
  if (typeof document === 'undefined' || document.location == null) return '';

  // Oh dear IE10...
  if (!document.location.origin) {
    return (
      document.location.protocol +
      '//' +
      document.location.hostname +
      (document.location.port ? ':' + document.location.port : '')
    );
  }

  return document.location.origin;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function() {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      if (element.url && element.url.substr(0, 5) === 'blob:') {
        // Special case for handling JavaScript loaded into a blob.
        // We use a synchronous AJAX request here as a blob is already in
        // memory - it's not making a network request.  This will generate a warning
        // in the browser console, but there has already been an error so that's not
        // that much of an issue.
        var xhr = new XMLHttpRequest();
        xhr.open('GET', element.url, false);
        xhr.send(null);

        // If we failed to download the source, skip this patch
        if (xhr.status === 200) {
          var source = xhr.responseText || '';

          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
          source = source.slice(-300);

          // Now we dig out the source map URL
          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);

          // If we don't find a source map comment or we find more than one, continue on to the next element.
          if (sourceMaps) {
            var sourceMapAddress = sourceMaps[1];

            // Now we check to see if it's a relative URL.
            // If it is, convert it to an absolute one.
            if (sourceMapAddress.charAt(0) === '~') {
              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
            }

            // Now we strip the '.map' off of the end of the URL and update the
            // element so that Sentry can match the map to the blob.
            element.url = sourceMapAddress.slice(0, -4);
          }
        }
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raven-js/vendor/json-stringify-safe/stringify.js":
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),

/***/ "../../node_modules/raven-js/vendor/md5/md5.js":
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),

/***/ "../../node_modules/react-is/cjs/react-is.production.min.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),

/***/ "../../node_modules/react-is/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("../../node_modules/react-is/cjs/react-is.production.min.js");
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),

/***/ "../../node_modules/react-redux/es/components/Provider.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__("../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__("../../node_modules/react-redux/es/utils/PropTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__("../../node_modules/react-redux/es/utils/warning.js");





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),

/***/ "../../node_modules/react-redux/es/components/connectAdvanced.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__("../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__("../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__("../../node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__("../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__("../../node_modules/react-redux/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__("../../node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__("../../node_modules/react-is/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__("../../node_modules/react-redux/es/utils/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__("../../node_modules/react-redux/es/utils/PropTypes.js");










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),

/***/ "../../node_modules/react-redux/es/connect/connect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__("../../node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__("../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__("../../node_modules/react-redux/es/components/connectAdvanced.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__("../../node_modules/react-redux/es/utils/shallowEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__("../../node_modules/react-redux/es/connect/mapDispatchToProps.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__("../../node_modules/react-redux/es/connect/mapStateToProps.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__("../../node_modules/react-redux/es/connect/mergeProps.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__("../../node_modules/react-redux/es/connect/selectorFactory.js");








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),

/***/ "../../node_modules/react-redux/es/connect/mapDispatchToProps.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__("../../node_modules/react-redux/es/connect/wrapMapToProps.js");


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),

/***/ "../../node_modules/react-redux/es/connect/mapStateToProps.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__("../../node_modules/react-redux/es/connect/wrapMapToProps.js");

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),

/***/ "../../node_modules/react-redux/es/connect/mergeProps.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__("../../node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__("../../node_modules/react-redux/es/utils/verifyPlainObject.js");


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),

/***/ "../../node_modules/react-redux/es/connect/selectorFactory.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__("../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__("../../node_modules/react-redux/es/connect/verifySubselectors.js");


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),

/***/ "../../node_modules/react-redux/es/connect/verifySubselectors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__("../../node_modules/react-redux/es/utils/warning.js");


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),

/***/ "../../node_modules/react-redux/es/connect/wrapMapToProps.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__("../../node_modules/react-redux/es/utils/verifyPlainObject.js");

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),

/***/ "../../node_modules/react-redux/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__("../../node_modules/react-redux/es/components/Provider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__("../../node_modules/react-redux/es/components/connectAdvanced.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__("../../node_modules/react-redux/es/connect/connect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),

/***/ "../../node_modules/react-redux/es/utils/PropTypes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),

/***/ "../../node_modules/react-redux/es/utils/Subscription.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),

/***/ "../../node_modules/react-redux/es/utils/isPlainObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),

/***/ "../../node_modules/react-redux/es/utils/shallowEqual.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),

/***/ "../../node_modules/react-redux/es/utils/verifyPlainObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__("../../node_modules/react-redux/es/utils/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__("../../node_modules/react-redux/es/utils/warning.js");


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),

/***/ "../../node_modules/react-redux/es/utils/warning.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),

/***/ "../../node_modules/react-redux/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__("../../node_modules/react-is/index.js");
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ "../../node_modules/redux/es/applyMiddleware.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__("../../node_modules/redux/es/compose.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),

/***/ "../../node_modules/redux/es/bindActionCreators.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),

/***/ "../../node_modules/redux/es/combineReducers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__("../../node_modules/redux/es/createStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__("../../node_modules/lodash-es/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__("../../node_modules/redux/es/utils/warning.js");




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),

/***/ "../../node_modules/redux/es/compose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),

/***/ "../../node_modules/redux/es/createStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__("../../node_modules/lodash-es/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__("../../node_modules/symbol-observable/es/index.js");



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),

/***/ "../../node_modules/redux/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__("../../node_modules/redux/es/createStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__("../../node_modules/redux/es/combineReducers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__("../../node_modules/redux/es/bindActionCreators.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__("../../node_modules/redux/es/applyMiddleware.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__("../../node_modules/redux/es/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__("../../node_modules/redux/es/utils/warning.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),

/***/ "../../node_modules/redux/es/utils/warning.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),

/***/ "../../node_modules/symbol-observable/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__("../../node_modules/symbol-observable/es/ponyfill.js");
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../node_modules/webpack/buildin/global.js"), __webpack_require__("../../node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "../../node_modules/symbol-observable/es/ponyfill.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),

/***/ "../../node_modules/webpack/buildin/global.js":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "../../node_modules/webpack/buildin/harmony-module.js":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./src/FinancingProvider.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../../node_modules/react-redux/es/index.js");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _lodash = __webpack_require__("lodash");

var _FinancingForm = __webpack_require__("./src/components/FinancingForm/FinancingForm.jsx");

var _FinancingForm2 = _interopRequireDefault(_FinancingForm);

var _redux = __webpack_require__("./src/providers/redux.js");

var _redux2 = _interopRequireDefault(_redux);

var _en = __webpack_require__("./src/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FinancingProvider = function (_React$Component) {
    _inherits(FinancingProvider, _React$Component);

    function FinancingProvider(props) {
        _classCallCheck(this, FinancingProvider);

        var _this = _possibleConstructorReturn(this, (FinancingProvider.__proto__ || Object.getPrototypeOf(FinancingProvider)).call(this, props));

        (0, _lodash.merge)(_en2.default, _widgetCommonsForms.Translations.en);
        (0, _lodash.merge)(_fr2.default, _widgetCommonsForms.Translations.fr);

        _widgetCommonsCoreServices.LocaleService.setLocale(props.locale);
        _widgetCommonsCoreServices.LocaleService.loadTranslations({ en: _en2.default, fr: _fr2.default });

        _widgetCommonsCoreServices.ConfigsService.setWebsiteId(props.websiteId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationId(props.organizationId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitId(props.organizationUnitId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitLocation(props.organizationUnitLocation);
        _widgetCommonsCoreServices.ConfigsService.setLocation(props.location);

        /* TODO: #improvement
         * WARNING their is no contentZones set for checkout. If the contentZones are needed please make sure that
         * Financing in checkout is not broken.
         */
        _widgetCommonsCoreServices.ContentZonesService.setImageServerBaseUrl(_index2.default.source.image);
        _widgetCommonsCoreServices.ContentZonesService.addContentZones(props.contentZones);

        _this.reduxStore = (0, _redux2.default)();
        _this.onUnload = _this.onUnload.bind(_this);
        return _this;
    }

    _createClass(FinancingProvider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.forceAuthentication();

            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.addEventListener('beforeunload', this.onUnload);
            }
            _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.FINANCING());
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.onUnload();
        }
    }, {
        key: 'onUnload',
        value: function onUnload() {
            _widgetCommonsGeneral.HistoryService.add(_widgetCommonsCoreServices.WindowProxy.location().href);
        }
    }, {
        key: 'onAuthenticationClose',
        value: function onAuthenticationClose() {
            var _this2 = this;

            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                _widgetCommonsGeneral.ProfileService.getLoggedAccountProfile().then(function (account) {
                    _this2.reduxStore.dispatch(_widgetCommonsGeneral.accountActions.setAccount(new _widgetCommonsGeneral.Account(account)));
                });
                return true;
            }
            if (_widgetCommonsCoreServices.WindowProxy.get()) {
                _widgetCommonsGeneral.HistoryService.goBackOrHome();
            }
            return false;
        }
    }, {
        key: 'forceAuthentication',
        value: function forceAuthentication() {
            var _this3 = this;

            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                var LoginModal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
                LoginModal.addCallbacks({
                    onClose: this.onAuthenticationClose
                });
                LoginModal.open();
            } else {
                _widgetCommonsGeneral.ProfileService.getLoggedAccountProfile().then(function (account) {
                    _this3.reduxStore.dispatch(_widgetCommonsGeneral.accountActions.setAccount(new _widgetCommonsGeneral.Account(account)));
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactRedux.Provider,
                { store: this.reduxStore },
                _react2.default.createElement(_FinancingForm2.default, null)
            );
        }
    }]);

    return FinancingProvider;
}(_react2.default.Component);

FinancingProvider.propTypes = {
    locale: _propTypes2.default.string.isRequired,
    websiteId: _propTypes2.default.number.isRequired,
    organizationId: _propTypes2.default.number.isRequired,
    organizationUnitId: _propTypes2.default.number.isRequired,
    organizationUnitLocation: _propTypes2.default.string.isRequired,
    location: _propTypes2.default.string.isRequired,
    contentZones: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
        active: _propTypes2.default.bool,
        group: _propTypes2.default.string,
        id: _propTypes2.default.number,
        location: _propTypes2.default.string,
        position: _propTypes2.default.number,
        type: _propTypes2.default.string,
        value: _propTypes2.default.string
    }))).isRequired
};

FinancingProvider.displayName = 'FinancingProvider';

exports.default = FinancingProvider;

/***/ }),

/***/ "./src/components/ApplicantInfosForm/ApplicantInfosForm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _moment = __webpack_require__("moment");

var _moment2 = _interopRequireDefault(_moment);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _profile = __webpack_require__("./src/constants/profile.js");

var _PersonalInfoDisplay = __webpack_require__("./src/components/ApplicantInfosForm/PersonalInfoDisplay.jsx");

var _PersonalInfoDisplay2 = _interopRequireDefault(_PersonalInfoDisplay);

var _ButtonBlock = __webpack_require__("./src/components/Utils/ButtonBlock.jsx");

var _ButtonBlock2 = _interopRequireDefault(_ButtonBlock);

var _ErrorService = __webpack_require__("./src/services/ErrorService/ErrorService.js");

var _ErrorService2 = _interopRequireDefault(_ErrorService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApplicantInfosForm = function (_React$Component) {
    _inherits(ApplicantInfosForm, _React$Component);

    function ApplicantInfosForm(props) {
        _classCallCheck(this, ApplicantInfosForm);

        var _this = _possibleConstructorReturn(this, (ApplicantInfosForm.__proto__ || Object.getPrototypeOf(ApplicantInfosForm)).call(this, props));

        var personalInformations = _this.props.personalInformations;


        _this.state = {
            isSubmitted: false,
            isValid: false,
            inputs: _extends({}, personalInformations, {
                dayOfBirth: personalInformations.dateOfBirth && personalInformations.dateOfBirth.getDay() || '',
                monthOfBirth: personalInformations.dateOfBirth && personalInformations.dateOfBirth.getMonth() || '',
                yearOfBirth: personalInformations.dateOfBirth && personalInformations.dateOfBirth.getFullYear() || ''
            }),
            formValidation: {
                identity: false,
                gender: !!personalInformations.gender,
                dateOfBirth: false
            },
            dateOfBirthValidation: {
                day: false,
                month: false,
                year: false
            },
            errors: []
        };

        _this.getPersonalInformationsErrors = _this.initializeErrors.bind(_this);
        _this.onBack = _this.onBack.bind(_this);
        _this.onDateOfBirthChanged = _this.onDateOfBirthChanged.bind(_this);
        _this.onDone = _this.onDone.bind(_this);
        _this.onGenderChange = _this.onGenderChange.bind(_this);
        _this.onIdentityChange = _this.onIdentityChange.bind(_this);
        _this.setEditModePersonalInfoForm = _this.setEditModePersonalInfoForm.bind(_this);
        _this.updateDateOfBirth = _this.updateDateOfBirth.bind(_this);
        _this.updateValidation = _this.updateValidation.bind(_this);
        return _this;
    }

    _createClass(ApplicantInfosForm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.updateValidation();
        }
    }, {
        key: 'onDone',
        value: function onDone() {
            var formValidation = this.state.formValidation;


            var errors = _ErrorService2.default.getErrors(formValidation, 'FINANCING.APPLICANT_INFO.ERRORS');

            this.setState({
                errors: errors,
                isSubmitted: true,
                isValid: !errors.length
            });

            this.props.onDone(_widgetCommonsForms.GroupResponseService.createResponse(!errors.length, this.state.inputs, null, null, 'personalInformations'));
        }
    }, {
        key: 'onBack',
        value: function onBack(callbackObject) {
            this.props.onBack(_widgetCommonsForms.GroupResponseService.createResponse(true, callbackObject, null, null, 'employmentInformations'));
        }
    }, {
        key: 'onGenderChange',
        value: function onGenderChange(e) {
            var newGender = parseInt(e.target.value, 10);

            this.setState(function (oldState) {
                var inputs = oldState.inputs,
                    formValidation = oldState.formValidation;

                inputs.gender = newGender;
                formValidation.gender = true;

                return {
                    inputs: inputs,
                    formValidation: formValidation
                };
            });
        }
    }, {
        key: 'onIdentityChange',
        value: function onIdentityChange(result) {
            this.setState(function (oldState) {
                var formValidation = oldState.formValidation,
                    inputs = oldState.inputs;

                formValidation.identity = !result.error;

                var updatedInputs = _extends({}, inputs, result.value);

                return {
                    formValidation: formValidation,
                    inputs: updatedInputs
                };
            });
        }
    }, {
        key: 'onDateOfBirthChanged',
        value: function onDateOfBirthChanged(newValue, inputName) {
            var _this2 = this;

            var value = parseInt(newValue, 10);

            this.setState(function (oldState) {
                var dateOfBirthValidation = oldState.dateOfBirthValidation;

                switch (inputName) {
                    case 'Day':
                        dateOfBirthValidation[inputName.toLowerCase()] = value && value <= 31 && value >= 1;
                        break;
                    case 'Month':
                        dateOfBirthValidation[inputName.toLowerCase()] = value && value <= 12 && value >= 1;
                        break;
                    case 'Year':
                        dateOfBirthValidation[inputName.toLowerCase()] = value && value <= new Date().getFullYear();
                        break;
                    default:
                        break;
                }

                return { dateOfBirthValidation: dateOfBirthValidation };
            }, function () {
                _this2.updateDateOfBirth(value, inputName);
            });
        }
    }, {
        key: 'setEditModePersonalInfoForm',
        value: function setEditModePersonalInfoForm(value) {
            this.setState({ editModePersonalInfoForm: value });
        }
    }, {
        key: 'updateValidation',
        value: function updateValidation() {
            var isIdentityInformationValid = !(0, _lodash.isEmpty)(this.state.inputs.firstname) && !(0, _lodash.isEmpty)(this.state.inputs.lastname) && _widgetCommonsForms.ValidationService.validatePhoneNumber(this.state.inputs.phoneNumber) && _widgetCommonsForms.ValidationService.validateEmail(this.state.inputs.email);

            this.setState(function (oldState) {
                return {
                    editModePersonalInfoForm: !isIdentityInformationValid,
                    formValidation: _extends({}, oldState.formValidation, {
                        identity: isIdentityInformationValid
                    })
                };
            });
        }
    }, {
        key: 'initializeErrors',
        value: function initializeErrors() {
            var personalInformations = this.props.personalInformations;
            var gender = personalInformations.gender,
                dayOfBirth = personalInformations.dayOfBirth,
                monthOfBirth = personalInformations.monthOfBirth,
                yearOfBirth = personalInformations.yearOfBirth;

            var errors = [];

            if (!gender || gender === '') {
                errors.push({
                    code: 'error.gender',
                    message: _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.ERRORS.GENDER')
                });
            }

            if (!(dayOfBirth && monthOfBirth && yearOfBirth)) {
                errors.push({
                    code: 'error.group.dateOfBirth',
                    message: _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.ERRORS.DATE_OF_BIRTH')
                });
            }

            return errors;
        }
    }, {
        key: 'updateDateOfBirth',
        value: function updateDateOfBirth(newValue, inputName) {
            var _state$inputs = this.state.inputs,
                dayOfBirth = _state$inputs.dayOfBirth,
                monthOfBirth = _state$inputs.monthOfBirth,
                yearOfBirth = _state$inputs.yearOfBirth;


            switch (inputName) {
                case 'Day':
                    dayOfBirth = newValue;
                    break;
                case 'Month':
                    monthOfBirth = newValue;
                    break;
                case 'Year':
                    yearOfBirth = newValue;
                    break;
                default:
                    break;
            }

            var dateOfBirthIsFull = dayOfBirth && monthOfBirth && yearOfBirth;

            this.setState(function (oldState) {
                var inputs = oldState.inputs,
                    formValidation = oldState.formValidation,
                    dateOfBirthValidation = oldState.dateOfBirthValidation;


                inputs.dayOfBirth = dayOfBirth;
                inputs.monthOfBirth = monthOfBirth;
                inputs.yearOfBirth = yearOfBirth;

                formValidation.dateOfBirth = false;

                if (dateOfBirthIsFull && dateOfBirthValidation.year && dateOfBirthValidation.month && dateOfBirthValidation.day) {
                    var dateOfBirth = (0, _moment2.default)([yearOfBirth, monthOfBirth - 1, dayOfBirth]);
                    formValidation.dateOfBirth = dateOfBirth.isValid();
                    if (formValidation.dateOfBirth) {
                        inputs.dateOfBirth = dateOfBirth.toDate();
                    } else {
                        inputs.dateOfBirth = null;
                    }
                }
                return { inputs: inputs, formValidation: formValidation };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                editModePersonalInfoForm = _state.editModePersonalInfoForm,
                inputs = _state.inputs,
                dateOfBirthValidation = _state.dateOfBirthValidation,
                errors = _state.errors,
                isSubmitted = _state.isSubmitted,
                isValid = _state.isValid;
            var gender = inputs.gender,
                dayOfBirth = inputs.dayOfBirth,
                monthOfBirth = inputs.monthOfBirth,
                yearOfBirth = inputs.yearOfBirth;
            var _props = this.props,
                isOpen = _props.isOpen,
                isCoApplicant = _props.isCoApplicant;

            var required = true;

            var personalInfoDisplay = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_PersonalInfoDisplay2.default, { informations: inputs, multiLine: required }),
                _react2.default.createElement(
                    'button',
                    { className: 'sr-link', onClick: function onClick() {
                            return _this3.setEditModePersonalInfoForm(true);
                        } },
                    this.props.isCoApplicant ? _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.EDIT_COAPPLICANT') : _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.EDIT_PRIMARY_APPLICANT'),
                    ' ',
                    '>'
                )
            );

            var identityLabels = {
                firstname: _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.FIRST_NAME'),
                lastname: _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.LAST_NAME'),
                phoneNumber: _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.PHONE_NUMBER'),
                email: _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.EMAIL')
            };

            var personalInfoForm = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_widgetCommonsForms.Groups.IdentityGroup, {
                    values: inputs,
                    labels: identityLabels,
                    onChange: this.onIdentityChange,
                    hasBeenSubmit: isSubmitted
                })
            );

            var applicantForm = _react2.default.createElement(
                'div',
                { className: 'clearfix' },
                !editModePersonalInfoForm ? personalInfoDisplay : personalInfoForm,
                _react2.default.createElement(
                    'div',
                    { className: 'financing-form-inline-gender clearfix' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'sr-text is-bold' },
                        _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.GENDER')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio-button-cta-wrapper' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-cta-wrapper--single' },
                            _react2.default.createElement('input', {
                                type: 'radio',
                                id: 'maleOption',
                                name: 'genderOption',
                                value: _profile.GENDERS.MALE,
                                checked: gender === _profile.GENDERS.MALE,
                                onChange: this.onGenderChange
                            }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'maleOption' },
                                _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.MALE')
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-cta-wrapper--single' },
                            _react2.default.createElement('input', {
                                type: 'radio',
                                id: 'femaleOption',
                                name: 'genderOption',
                                value: _profile.GENDERS.FEMALE,
                                checked: gender === _profile.GENDERS.FEMALE,
                                onChange: this.onGenderChange
                            }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'femaleOption' },
                                _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.FEMALE')
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'financing-form-inline-birth clearfix' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'sr-text is-bold' },
                        _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.DATE_OF_BIRTH')
                    ),
                    _react2.default.createElement(_widgetCommonsForms.InputText, {
                        label: _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.YEAR'),
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.USER_YEAR'),
                        name: 'Year',
                        type: 'number',
                        value: yearOfBirth,
                        classNames: ['styled-placeholder quarter'],
                        isValid: dateOfBirthValidation.year,
                        isRequired: required,
                        valueChange: this.onDateOfBirthChanged,
                        hasBeenSubmit: isSubmitted,
                        maxLength: _widgetCommonsForms.FIELD_LENGTH.YEAR_MAX
                    }),
                    _react2.default.createElement(_widgetCommonsForms.InputText, {
                        label: _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.MONTH'),
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.USER_MONTH'),
                        name: 'Month',
                        type: 'number',
                        value: monthOfBirth,
                        classNames: ['styled-placeholder quarter'],
                        isValid: dateOfBirthValidation.month,
                        isRequired: required,
                        valueChange: this.onDateOfBirthChanged,
                        hasBeenSubmit: isSubmitted,
                        maxLength: _widgetCommonsForms.FIELD_LENGTH.MONTH_MAX
                    }),
                    _react2.default.createElement(_widgetCommonsForms.InputText, {
                        label: _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.DAY'),
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.USER_DAY'),
                        name: 'Day',
                        type: 'number',
                        value: dayOfBirth,
                        classNames: ['styled-placeholder quarter'],
                        isValid: dateOfBirthValidation.day,
                        isRequired: required,
                        valueChange: this.onDateOfBirthChanged,
                        hasBeenSubmit: isSubmitted,
                        maxLength: _widgetCommonsForms.FIELD_LENGTH.DAY_MAX
                    })
                ),
                errors.length !== 0 && isSubmitted && isOpen && _react2.default.createElement(
                    'p',
                    { className: 'financing__content-errors-message' },
                    _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.TITLE')
                ),
                _react2.default.createElement(_ButtonBlock2.default, { onBack: isCoApplicant ? this.onBack : undefined, onDone: this.onDone })
            );
            var formClass = isOpen ? 'financingBlockForm applicantForm is-open' : 'financingBlockForm applicantForm is-closed ' + (isValid ? 'is-valid' : '');

            return _react2.default.createElement(
                'div',
                { className: formClass },
                _react2.default.createElement('icon', { className: 'icon-Crochet is-util' }),
                errors.length !== 0 && isSubmitted && isOpen && _react2.default.createElement(_widgetCommonsForms.ErrorsHandler, { errors: errors }),
                _react2.default.createElement(
                    'h3',
                    { className: 'sr-text is-bold is-util' },
                    this.props.isCoApplicant ? _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.WHO_IS_COAPPLICANT') : _widgetCommonsCoreServices.LocaleService.t('FINANCING.APPLICANT_INFO.WHO_IS_PRIMARY_APPLICANT')
                ),
                _react2.default.createElement('br', null),
                isOpen ? applicantForm : _react2.default.createElement(_PersonalInfoDisplay2.default, { informations: inputs })
            );
        }
    }]);

    return ApplicantInfosForm;
}(_react2.default.Component);

ApplicantInfosForm.defaultProps = {
    isCoApplicant: false,
    isOpen: true,
    onBack: _lodash.noop
};

ApplicantInfosForm.propTypes = {
    isCoApplicant: _propTypes2.default.bool,
    isOpen: _propTypes2.default.bool,
    onBack: _propTypes2.default.func,
    onDone: _propTypes2.default.func.isRequired,
    personalInformations: _propTypes2.default.shape({
        dateOfBirth: _propTypes2.default.instanceOf(Date),
        email: _propTypes2.default.string.isRequired,
        firstname: _propTypes2.default.string.isRequired,
        gender: _propTypes2.default.string.isRequired,
        lastname: _propTypes2.default.string.isRequired,
        phoneNumber: _propTypes2.default.string.isRequired
    }).isRequired
};

ApplicantInfosForm.displayName = 'ApplicantInfosForm';

exports.default = ApplicantInfosForm;

/***/ }),

/***/ "./src/components/ApplicantInfosForm/PersonalInfoDisplay.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalInfoDisplay = function PersonalInfoDisplay(_ref) {
    var informations = _ref.informations,
        multiLine = _ref.multiLine;

    var formattedPhoneNumber = function formattedPhoneNumber(phone) {
        if (!phone) {
            return '';
        }
        var areaCode = phone.charAt(0) === '+' ? '(' + phone.substr(2, 3) + ')' : '(' + phone.substr(0, 3) + ')';
        var phoneNumber = phone.charAt(0) === '+' ? phone.substr(5, 3) + '-' + phone.substr(8) : phone.substr(3, 3) + '-' + phone.substr(6);

        return areaCode + ' ' + phoneNumber;
    };

    return multiLine ? _react2.default.createElement(
        'div',
        { className: 'personalInfo' },
        _react2.default.createElement(
            'span',
            null,
            informations.firstname + ' ' + informations.lastname
        ),
        _react2.default.createElement(
            'span',
            null,
            formattedPhoneNumber(informations.phoneNumber)
        ),
        _react2.default.createElement(
            'span',
            null,
            informations.email
        )
    ) : _react2.default.createElement(
        'span',
        null,
        informations.firstname + ' ' + informations.lastname
    );
};

PersonalInfoDisplay.defaultProps = {
    multiLine: false
};

PersonalInfoDisplay.propTypes = {
    informations: _propTypes2.default.shape({
        firstname: _propTypes2.default.string.isRequired,
        lastname: _propTypes2.default.string.isRequired,
        phoneNumber: _propTypes2.default.string.isRequired,
        email: _propTypes2.default.string.isRequired
    }).isRequired,
    multiLine: _propTypes2.default.bool
};

PersonalInfoDisplay.displayName = 'PersonalInfoDisplay';

exports.default = PersonalInfoDisplay;

/***/ }),

/***/ "./src/components/DepositState/DepositState.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

__webpack_require__("./src/components/DepositState/DepositState.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DepositState = function DepositState(_ref) {
    var depositAmount = _ref.depositAmount;

    return _react2.default.createElement(
        'div',
        { className: 'confirm_deposit--wrapper' },
        _react2.default.createElement(
            'div',
            { className: 'confirm_deposit--icon' },
            _react2.default.createElement('icon', { className: 'icon-Crochet' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'confirm_deposit--content' },
            _react2.default.createElement(
                'p',
                { className: 'confirm_deposit--title is-bold' },
                ' ',
                _widgetCommonsCoreServices.LocaleService.t('FINANCING.DEPOSIT.CONGRATS')
            ),
            _react2.default.createElement(
                'p',
                { className: 'confirm_deposit--subtitle sr-text is-bold' },
                _widgetCommonsCoreServices.LocaleService.t('FINANCING.DEPOSIT.TITLE', {
                    amount: depositAmount
                })
            ),
            _react2.default.createElement(
                'p',
                null,
                _widgetCommonsCoreServices.LocaleService.t('FINANCING.DEPOSIT.SUBTITLE')
            )
        )
    );
};

DepositState.defaultProps = {
    depositAmount: 500
};

DepositState.propTypes = {
    depositAmount: _propTypes2.default.number
};

DepositState.displayName = 'DepositState';

exports.default = DepositState;

/***/ }),

/***/ "./src/components/DepositState/DepositState.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/EmploymentInfosForm/EmploymentInfosConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__("./src/constants/localization.js");

var _employment = __webpack_require__("./src/constants/employment.js");

var workInputs = [{
    inputName: 'employer',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYER',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.EMPLOYER',
    inputType: 'text',
    isRequired: true,
    classNames: 'half'
}, {
    inputName: 'occupation',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.OCCUPATION',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.OCCUPATION',
    inputType: 'text',
    isRequired: true,
    classNames: 'half'
}, {
    inputName: 'yearsAtEmployment',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.YEARS_AT_EMPLOYMENT',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.YEARS_AT_EMPLOYMENT',
    inputType: 'number',
    isRequired: true,
    classNames: 'half'
}, {
    inputName: 'monthsAtEmployment',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.MONTHS_AT_EMPLOYMENT',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.MONTHS_AT_EMPLOYMENT',
    inputType: 'number',
    isRequired: true,
    classNames: 'half'
}, {
    inputType: 'subhead',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYER_ADDRESS' // TODO: # fix unknown key
}];

var employerAddressInputs = [{
    inputName: 'streetNumber',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_NUMBER',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.STREET_NUMBER',
    inputType: 'text',
    isRequired: false,
    classNames: 'third'
}, {
    inputName: 'streetName',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_NAME',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.STREET_NAME',
    inputType: 'text',
    isRequired: true,
    classNames: 'third'
}, {
    inputName: 'streetType',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPE',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.STREET_TYPE',
    inputType: 'dropdown',
    isRequired: true,
    classNames: 'third',
    options: _localization.STREET_TYPES
}, {
    inputName: 'unitNumber',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.UNIT_NUMBER',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.UNIT_NUMBER',
    inputType: 'text',
    isRequired: false,
    classNames: 'full'
}, {
    inputName: 'postalCode',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.POSTAL_CODE',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.POSTAL_CODE',
    inputType: 'postalCode',
    isRequired: true,
    classNames: 'third'
}, {
    inputName: 'city',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.CITY',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.CITY',
    inputType: 'text',
    isRequired: true,
    classNames: 'third'
}, {
    inputName: 'province',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.PROVINCE',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.PROVINCE',
    inputType: 'dropdown',
    isRequired: true,
    classNames: 'third',
    options: _localization.PROVINCES
}, {
    inputName: 'phoneNumber',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.PHONE_NUMBER',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.PHONE_NUMBER',
    inputType: 'phone',
    isRequired: true,
    classNames: 'double-third'
}, {
    inputName: 'phoneExtension',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.PHONE_EXTENSION',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.PHONE_EXTENSION',
    inputType: 'tel',
    isRequired: false,
    classNames: 'third'
}];

var incomeInputs = [{
    inputName: 'incomes',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOMES',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.INCOMES',
    inputType: 'dropdown',
    isRequired: true,
    classNames: 'half',
    options: _employment.FINANCING_FREQUENCIES
}, {
    inputName: 'incomeGross',
    transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOME_GROSS',
    errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.INCOME_GROSS',
    inputType: 'number',
    isRequired: true,
    classNames: 'half'
}];

var employedInputs = [].concat(workInputs, employerAddressInputs, incomeInputs);

var employmentInfosConfig = {
    employed: employedInputs,
    selfEmployed: employedInputs,
    retired: incomeInputs,
    unemployed: [],
    student: [],
    other: []
};

exports.default = employmentInfosConfig;

/***/ }),

/***/ "./src/components/EmploymentInfosForm/EmploymentInfosForm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _employment = __webpack_require__("./src/constants/employment.js");

var _incomes = __webpack_require__("./src/constants/incomes.js");

var _EmploymentInfosConfig = __webpack_require__("./src/components/EmploymentInfosForm/EmploymentInfosConfig.js");

var _EmploymentInfosConfig2 = _interopRequireDefault(_EmploymentInfosConfig);

var _ErrorService = __webpack_require__("./src/services/ErrorService/ErrorService.js");

var _ErrorService2 = _interopRequireDefault(_ErrorService);

var _FormBuilder = __webpack_require__("./src/components/Utils/FormBuilder.jsx");

var _FormBuilder2 = _interopRequireDefault(_FormBuilder);

var _ButtonBlock = __webpack_require__("./src/components/Utils/ButtonBlock.jsx");

var _ButtonBlock2 = _interopRequireDefault(_ButtonBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmploymentInfosForm = function (_React$Component) {
    _inherits(EmploymentInfosForm, _React$Component);

    function EmploymentInfosForm(props) {
        _classCallCheck(this, EmploymentInfosForm);

        var _this = _possibleConstructorReturn(this, (EmploymentInfosForm.__proto__ || Object.getPrototypeOf(EmploymentInfosForm)).call(this, props));

        _this.state = {
            isSubmitted: false,
            isValid: false,
            employmentType: '',
            employmentStatus: '',
            employmentInfos: {},
            withOtherIncome: false,
            otherIncomeType: '',
            otherIncomeFrequency: '',
            otherIncomeAmount: 0,
            formValidation: {
                employmentType: false,
                employmentStatus: false
            },
            otherIncomeValidation: {
                otherIncomeType: '',
                otherIncomeFrequency: '',
                otherIncomeAmount: 0
            },
            employmentInfosValidation: {},
            errors: []
        };

        _this.onEmploymentValueChange = _this.onEmploymentValueChange.bind(_this);
        _this.onEmploymentTypeChange = _this.onEmploymentTypeChange.bind(_this);
        _this.onEmploymentStatusChange = _this.onEmploymentStatusChange.bind(_this);
        _this.onOtherIncomeStatusChanged = _this.onOtherIncomeStatusChanged.bind(_this);
        _this.onOtherIncomeTypeChanged = _this.onOtherIncomeTypeChanged.bind(_this);
        _this.onOtherIncomeFrequencyChanged = _this.onOtherIncomeFrequencyChanged.bind(_this);
        _this.onOtherIncomeAmountChanged = _this.onOtherIncomeAmountChanged.bind(_this);
        _this.onOtherIncomeStatusChanged = _this.onOtherIncomeStatusChanged.bind(_this);
        _this.onDone = _this.onDone.bind(_this);
        _this.onBack = _this.onBack.bind(_this);
        return _this;
    }

    _createClass(EmploymentInfosForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.employmentTypes = _employment.EMPLOYMENT_TYPES.map(function (type) {
                return _extends({}, type, {
                    label: _widgetCommonsCoreServices.LocaleService.t(type.transKey)
                });
            });

            this.employmentStatuses = _employment.EMPLOYMENT_STATUS.map(function (status) {
                return _extends({}, status, {
                    label: _widgetCommonsCoreServices.LocaleService.t(status.transKey)
                });
            });

            this.externalIncomes = _incomes.EXTERNAL_INCOMES.map(function (income) {
                return _extends({}, income, {
                    label: _widgetCommonsCoreServices.LocaleService.t(income.transKey)
                });
            });

            this.financingFrequencies = _employment.FINANCING_FREQUENCIES.map(function (frequency) {
                return _extends({}, frequency, {
                    label: _widgetCommonsCoreServices.LocaleService.t(frequency.transKey)
                });
            });
        }
    }, {
        key: 'onDone',
        value: function onDone(callbackObject) {
            var _state = this.state,
                withOtherIncome = _state.withOtherIncome,
                formValidation = _state.formValidation,
                otherIncomeValidation = _state.otherIncomeValidation,
                employmentInfosValidation = _state.employmentInfosValidation;


            var errors = _ErrorService2.default.getErrors(formValidation, 'FINANCING.EMPLOYMENT_INFOS.ERRORS');

            if (!(0, _lodash.every)(employmentInfosValidation)) {
                errors.push({
                    code: 'error.employmentInfos',
                    message: _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.ERRORS.EMPLOYMENT_INFOS')
                });
            }

            if (withOtherIncome && !(0, _lodash.every)(otherIncomeValidation)) {
                errors.push({
                    code: 'error.otherIncome',
                    message: _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.ERRORS.OTHER_INCOME')
                });
            }

            this.setState({
                errors: errors,
                isSubmitted: true,
                isValid: !errors.length
            });

            this.props.onDone(_widgetCommonsForms.GroupResponseService.createResponse(!errors.length, callbackObject, null, null, 'employmentInformations'));
        }
    }, {
        key: 'onBack',
        value: function onBack(callbackObject) {
            this.props.onBack(_widgetCommonsForms.GroupResponseService.createResponse(true, callbackObject, null, null, 'employmentInformations'));
        }
    }, {
        key: 'onEmploymentTypeChange',
        value: function onEmploymentTypeChange(newValue) {
            if (!newValue) {
                return;
            }

            this.setState(function (oldState) {
                var formValidation = oldState.formValidation;


                var employmentInfosValidation = {};
                (0, _lodash.each)(_EmploymentInfosConfig2.default[newValue.value], function (input) {
                    employmentInfosValidation[input.inputName] = !input.isRequired;
                });

                formValidation.employmentType = true;

                return {
                    formValidation: formValidation,
                    employmentInfosValidation: employmentInfosValidation,
                    employmentType: newValue.value,
                    employmentInfos: {}
                };
            });
        }
    }, {
        key: 'onEmploymentStatusChange',
        value: function onEmploymentStatusChange(newValue) {
            if (!newValue) {
                return;
            }

            this.setState(function (oldState) {
                var formValidation = oldState.formValidation;


                formValidation.employmentStatus = true;

                return {
                    formValidation: formValidation,
                    employmentStatus: newValue.value
                };
            });
        }
    }, {
        key: 'onEmploymentValueChange',
        value: function onEmploymentValueChange(newValue, inputName, isValid) {
            this.setState(function (oldState) {
                var employmentInfos = oldState.employmentInfos,
                    employmentInfosValidation = oldState.employmentInfosValidation;


                employmentInfos[inputName] = newValue;
                employmentInfosValidation[inputName] = isValid;

                return { employmentInfos: employmentInfos, employmentInfosValidation: employmentInfosValidation };
            });
        }
    }, {
        key: 'onOtherIncomeTypeChanged',
        value: function onOtherIncomeTypeChanged(newValue) {
            this.setState(function (oldState) {
                var otherIncomeValidation = oldState.otherIncomeValidation;


                if (newValue && newValue !== '') {
                    otherIncomeValidation.otherIncomeType = true;
                }

                return {
                    otherIncomeValidation: otherIncomeValidation,
                    otherIncomeType: newValue.value
                };
            });
        }
    }, {
        key: 'onOtherIncomeFrequencyChanged',
        value: function onOtherIncomeFrequencyChanged(newValue) {
            this.setState(function (oldState) {
                var otherIncomeValidation = oldState.otherIncomeValidation;


                if (newValue && newValue !== '') {
                    otherIncomeValidation.otherIncomeFrequency = true;
                }

                return {
                    otherIncomeValidation: otherIncomeValidation,
                    otherIncomeFrequency: newValue.value
                };
            });
        }
    }, {
        key: 'onOtherIncomeAmountChanged',
        value: function onOtherIncomeAmountChanged(newValue) {
            this.setState(function (oldState) {
                var otherIncomeValidation = oldState.otherIncomeValidation;


                if (newValue && newValue !== '') {
                    otherIncomeValidation.otherIncomeAmount = true;
                }

                return {
                    otherIncomeValidation: otherIncomeValidation,
                    otherIncomeAmount: newValue
                };
            });
        }
    }, {
        key: 'onOtherIncomeStatusChanged',
        value: function onOtherIncomeStatusChanged(event) {
            var newValue = event.currentTarget.value === 'yes';

            this.setState({
                withOtherIncome: newValue
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isOpen = this.props.isOpen;
            var _state2 = this.state,
                employmentInfos = _state2.employmentInfos,
                employmentInfosValidation = _state2.employmentInfosValidation,
                employmentType = _state2.employmentType,
                employmentStatus = _state2.employmentStatus,
                formValidation = _state2.formValidation,
                otherIncomeType = _state2.otherIncomeType,
                otherIncomeFrequency = _state2.otherIncomeFrequency,
                otherIncomeAmount = _state2.otherIncomeAmount,
                otherIncomeValidation = _state2.otherIncomeValidation,
                withOtherIncome = _state2.withOtherIncome,
                isSubmitted = _state2.isSubmitted,
                isValid = _state2.isValid,
                errors = _state2.errors;


            var employmentTypeFormBlock = null;
            if (employmentType) {
                employmentTypeFormBlock = _EmploymentInfosConfig2.default[employmentType].map(function (input) {
                    return _react2.default.createElement(_FormBuilder2.default, {
                        key: input.inputName,
                        inputParams: _extends({}, input, { value: employmentInfos[input.inputName] }),
                        isValid: employmentInfosValidation[input.inputName],
                        onChange: _this2.onEmploymentValueChange,
                        hasBeenSubmit: isSubmitted,
                        errorLabel: input.errorTransKey
                    });
                });
            }

            var employmentForm = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    { className: 'sr-text is-bold' },
                    _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.YOUR_WORK')
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                        name: 'employmentType',
                        classNames: ['third'],
                        options: this.employmentTypes,
                        placeholder: _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPE'),
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.EMPLOYMENT_TYPE'),
                        value: employmentType,
                        valueChange: this.onEmploymentTypeChange,
                        isRequired: true,
                        isValid: formValidation.employmentType,
                        hasBeenSubmit: isSubmitted
                    }),
                    _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                        name: 'employmentStatus',
                        classNames: ['third'],
                        options: this.employmentStatuses,
                        placeholder: _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUS'),
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.EMPLOYMENT_STATUS'),
                        value: employmentStatus,
                        valueChange: this.onEmploymentStatusChange,
                        isRequired: true,
                        isValid: formValidation.employmentStatus,
                        hasBeenSubmit: isSubmitted
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    employmentTypeFormBlock
                )
            );

            var extendedOtherIncomeBlock = _react2.default.createElement(
                'div',
                { className: 'clearfix' },
                _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                    name: 'otherIncomeType',
                    classNames: ['third'],
                    options: this.externalIncomes,
                    placeholder: _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.OTHER_INCOME'),
                    value: otherIncomeType,
                    valueChange: this.onOtherIncomeTypeChanged,
                    isValid: otherIncomeValidation.otherIncomeType,
                    hasBeenSubmit: isSubmitted
                }),
                _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                    name: 'otherIncomeFrequency',
                    classNames: ['third'],
                    options: this.financingFrequencies,
                    value: otherIncomeFrequency,
                    valueChange: this.onOtherIncomeFrequencyChanged,
                    placeholder: _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_FREQUENCY'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.OTHER_INCOME_FREQUENCY'),
                    isValid: otherIncomeValidation.otherIncomeFrequency,
                    hasBeenSubmit: isSubmitted
                }),
                _react2.default.createElement(_widgetCommonsForms.InputText, {
                    type: 'number',
                    name: 'otherIncomeAmount',
                    classNames: ['styled-placeholder', 'third', 'currency'],
                    label: _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.INCOME_AMOUNT'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.INCOME_AMOUNT'),
                    value: otherIncomeAmount,
                    valueChange: this.onOtherIncomeAmountChanged,
                    isValid: otherIncomeValidation.otherIncomeAmount,
                    hasBeenSubmit: isSubmitted,
                    maxLength: _widgetCommonsForms.FIELD_LENGTH.DEFAULT_NUMBER_MAX
                })
            );

            var otherIncomeForm = _react2.default.createElement(
                'div',
                { className: 'clearfix' },
                _react2.default.createElement(
                    'h4',
                    { className: 'sr-text is-bold' },
                    _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME')
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    _react2.default.createElement(
                        'div',
                        { className: 'styled-placeholder third' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-cta-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'radio-button-cta-wrapper--single' },
                                _react2.default.createElement('input', {
                                    type: 'radio',
                                    id: 'yesOption',
                                    name: 'hasOtherIncome',
                                    value: 'yes',
                                    onChange: this.onOtherIncomeStatusChanged,
                                    checked: this.state.withOtherIncome
                                }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'yesOption' },
                                    _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.YES_OPTION')
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'radio-button-cta-wrapper--single' },
                                _react2.default.createElement('input', {
                                    type: 'radio',
                                    id: 'noOption',
                                    name: 'hasOtherIncome',
                                    value: 'no',
                                    onChange: this.onOtherIncomeStatusChanged,
                                    checked: !this.state.withOtherIncome
                                }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'noOption' },
                                    _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.NO_OPTION')
                                )
                            )
                        )
                    )
                ),
                withOtherIncome && extendedOtherIncomeBlock
            );

            var formClass = isOpen ? 'financingBlockForm employmentForm is-open' : 'financingBlockForm employmentForm is-closed ' + (isValid ? 'is-valid' : '');

            var callbackObject = _extends({
                type: employmentType,
                status: employmentStatus,
                otherIncome: {
                    type: otherIncomeType,
                    frequency: otherIncomeFrequency,
                    amount: otherIncomeAmount && otherIncomeAmount
                }
            }, employmentInfos);

            return _react2.default.createElement(
                'div',
                { className: formClass },
                _react2.default.createElement('icon', { className: 'icon-Crochet is-util' }),
                errors.length !== 0 && isSubmitted && isOpen && _react2.default.createElement(_widgetCommonsForms.ErrorsHandler, { errors: errors }),
                _react2.default.createElement(
                    'h3',
                    { className: 'sr-text is-bold is-util ' },
                    _widgetCommonsCoreServices.LocaleService.t('FINANCING.EMPLOYMENT_INFOS.WHAT_ABOUT_CURRENT_EMPLOYMENT')
                ),
                _react2.default.createElement('br', null),
                isOpen && employmentForm,
                isOpen && otherIncomeForm,
                errors.length !== 0 && isSubmitted && isOpen && _react2.default.createElement(
                    'p',
                    { className: 'financing__content-errors-message' },
                    _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.TITLE')
                ),
                isOpen && _react2.default.createElement(_ButtonBlock2.default, {
                    onBack: function onBack() {
                        return _this2.onBack(callbackObject);
                    },
                    onDone: function onDone() {
                        return _this2.onDone(callbackObject);
                    }
                })
            );
        }
    }]);

    return EmploymentInfosForm;
}(_react2.default.Component);

EmploymentInfosForm.defaultProps = {
    isOpen: true
};

EmploymentInfosForm.propTypes = {
    isOpen: _propTypes2.default.bool,
    onBack: _propTypes2.default.func.isRequired,
    onDone: _propTypes2.default.func.isRequired
};

EmploymentInfosForm.displayName = 'EmploymentInfosForm';

exports.default = EmploymentInfosForm;

/***/ }),

/***/ "./src/components/Financing/Financing.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Financing = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../../node_modules/react-redux/es/index.js");

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _ApplicantInfosForm = __webpack_require__("./src/components/ApplicantInfosForm/ApplicantInfosForm.jsx");

var _ApplicantInfosForm2 = _interopRequireDefault(_ApplicantInfosForm);

var _ResidenceInfosForm = __webpack_require__("./src/components/ResidenceInfosForm/ResidenceInfosForm.jsx");

var _ResidenceInfosForm2 = _interopRequireDefault(_ResidenceInfosForm);

var _EmploymentInfosForm = __webpack_require__("./src/components/EmploymentInfosForm/EmploymentInfosForm.jsx");

var _EmploymentInfosForm2 = _interopRequireDefault(_EmploymentInfosForm);

var _JointInfosForm = __webpack_require__("./src/components/JointInfosForm/JointInfosForm.jsx");

var _JointInfosForm2 = _interopRequireDefault(_JointInfosForm);

var _FinancingService = __webpack_require__("./src/services/FinancingService/FinancingService.js");

var _FinancingService2 = _interopRequireDefault(_FinancingService);

var _FinancingMapperService = __webpack_require__("./src/services/FinancingMapperService/FinancingMapperService.js");

var _FinancingMapperService2 = _interopRequireDefault(_FinancingMapperService);

var _financing = __webpack_require__("./src/constants/financing.js");

__webpack_require__("./src/components/Financing/Financing.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Financing = function (_React$Component) {
    _inherits(Financing, _React$Component);

    function Financing(props) {
        _classCallCheck(this, Financing);

        var _this = _possibleConstructorReturn(this, (Financing.__proto__ || Object.getPrototypeOf(Financing)).call(this, props));

        var account = props.account.toObject();

        _this.state = {
            creditApplicationId: '',
            openFormIndex: 0,
            stepCount: 4, // eslint-disable-line react/no-unused-state
            hasCoApplicant: false,
            primaryApplicant: {
                personalInformations: _extends({}, (0, _lodash.pick)(account, ['firstname', 'lastname', 'dateOfBirth']), {
                    phoneNumber: account.homePhone,
                    email: account.email1,
                    gender: account.sexId
                }),
                residenceInformations: {
                    address: (0, _lodash.pick)(account, ['address', 'address2', 'city', 'province', 'country', 'postalCode'])
                },
                employmentInformations: {},
                validations: {
                    personalInformations: false,
                    residenceInformations: false,
                    employmentInformations: false,
                    joinApplicationDone: false
                }
            },
            coApplicant: {
                personalInformations: {
                    firstname: '',
                    lastname: '',
                    phoneNumber: '',
                    email: '',
                    gender: '',
                    dateOfBirth: null
                },
                residenceInformations: {
                    address: {
                        address: '',
                        address2: '',
                        city: '',
                        province: '',
                        country: '',
                        postalCode: ''
                    }
                },
                employmentInformations: {},
                validations: {
                    personalInformations: false,
                    residenceInformations: false,
                    employmentInformations: false
                }
            }
        };

        _this.nextForm = _this.nextForm.bind(_this);
        _this.previousForm = _this.previousForm.bind(_this);
        _this.onDone = _this.onDone.bind(_this);
        _this.onGoBack = _this.onGoBack.bind(_this);
        _this.saveFinancing = _this.saveFinancing.bind(_this);
        _this.onJointInfoOptionChange = _this.onJointInfoOptionChange.bind(_this);
        _this.updateApplicantInformations = _this.updateApplicantInformations.bind(_this);
        _this.updateResidenceInformations = _this.updateResidenceInformations.bind(_this);
        _this.updateEmploymentInformations = _this.updateEmploymentInformations.bind(_this);
        _this.executeGAVirtualPageView = _this.executeGAVirtualPageView.bind(_this);
        return _this;
    }

    _createClass(Financing, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.CHECKOUT_FINANCING_PERSONAL_INFO());
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            var newAccountRecord = newProps.account;
            var oldAccountRecord = this.props.account;

            if (newAccountRecord && oldAccountRecord && !newAccountRecord.equals(oldAccountRecord)) {
                this.setState({
                    primaryApplicant: {
                        personalInformations: _extends({}, (0, _lodash.pick)(newAccountRecord, ['firstname', 'lastname', 'gender', 'dateOfBirth']), {
                            phoneNumber: newAccountRecord.homePhone,
                            email: newAccountRecord.email1,
                            gender: newAccountRecord.sexId
                        }),
                        residenceInformations: {
                            address: (0, _lodash.pick)(newAccountRecord, ['address', 'address2', 'city', 'province', 'country', 'postalCode'])
                        },
                        employmentInformations: {},
                        validations: {
                            personalInformations: false,
                            residenceInformations: false,
                            employmentInformations: false,
                            joinApplicationDone: false
                        }
                    }
                });
            }
        }
    }, {
        key: 'onDone',
        value: function onDone(groupResponse, isCoApplicant) {
            function saveCreditApplication() {
                if (groupResponse.valid) {
                    this.saveCreditApplication();
                    this.nextForm();
                }
            }

            if (groupResponse.name === 'personalInformations') {
                this.updateApplicantInformations(groupResponse, isCoApplicant, saveCreditApplication);
            } else if (groupResponse.name === 'residenceInformations') {
                this.updateResidenceInformations(groupResponse, isCoApplicant, saveCreditApplication);
            } else if (groupResponse.name === 'employmentInformations') {
                this.updateEmploymentInformations(groupResponse, isCoApplicant, saveCreditApplication);
            }
        }
    }, {
        key: 'onGoBack',
        value: function onGoBack(groupResponse, isCoApplicant) {
            if (groupResponse.name === 'personalInformations') {
                this.updateApplicantInformations(groupResponse, isCoApplicant, this.previousForm);
            } else if (groupResponse.name === 'residenceInformations') {
                this.updateResidenceInformations(groupResponse, isCoApplicant, this.previousForm);
            } else if (groupResponse.name === 'employmentInformations') {
                this.updateEmploymentInformations(groupResponse, isCoApplicant, this.previousForm);
            }
        }
    }, {
        key: 'onJointInfoOptionChange',
        value: function onJointInfoOptionChange(hasCoApplicant) {
            var primaryApplicant = this.state.primaryApplicant;


            primaryApplicant.validations.joinApplicationDone = true;

            this.setState({
                hasCoApplicant: hasCoApplicant,
                stepCount: hasCoApplicant ? 7 : 4, // eslint-disable-line react/no-unused-state
                primaryApplicant: primaryApplicant
            });

            this.saveCreditApplication();
            this.nextForm();
        }
    }, {
        key: 'updateResidenceInformations',
        value: function updateResidenceInformations(groupResponse, isCoApplicant, stateCallback) {
            this.setState(function (oldState) {
                var newApplicantResidenceInfo = _extends({}, groupResponse.value.inputs, {
                    housingType: groupResponse.value.housingType,
                    housingValues: groupResponse.value.housingValues
                });

                if (isCoApplicant) {
                    var coApplicant = oldState.coApplicant;

                    coApplicant.residenceInformations = newApplicantResidenceInfo;
                    coApplicant.validations.residenceInformations = groupResponse.valid;
                    return { coApplicant: coApplicant };
                }

                var primaryApplicant = oldState.primaryApplicant;

                primaryApplicant.residenceInformations = newApplicantResidenceInfo;
                primaryApplicant.validations.residenceInformations = groupResponse.valid;
                return { primaryApplicant: primaryApplicant };
            }, stateCallback);
        }
    }, {
        key: 'updateEmploymentInformations',
        value: function updateEmploymentInformations(groupResponse, isCoApplicant, stateCallback) {
            this.setState(function (oldState) {
                if (isCoApplicant) {
                    var coApplicant = oldState.coApplicant;

                    coApplicant.employmentInformations = groupResponse.value;
                    coApplicant.validations.employmentInformations = groupResponse.valid;
                    return { coApplicant: coApplicant };
                }

                var primaryApplicant = oldState.primaryApplicant;

                primaryApplicant.employmentInformations = groupResponse.value;
                primaryApplicant.validations.employmentInformations = groupResponse.valid;
                return { primaryApplicant: primaryApplicant };
            }, stateCallback);
        }
    }, {
        key: 'updateApplicantInformations',
        value: function updateApplicantInformations(groupResponse, isCoApplicant, stateCallback) {
            this.setState(function (oldState) {
                if (isCoApplicant) {
                    var coApplicant = oldState.coApplicant;

                    coApplicant.personalInformations = groupResponse.value;
                    coApplicant.validations.personalInformations = groupResponse.valid;
                    return { coApplicant: coApplicant };
                }

                var primaryApplicant = oldState.primaryApplicant;

                primaryApplicant.personalInformations = groupResponse.value;
                primaryApplicant.validations.personalInformations = groupResponse.valid;
                return { primaryApplicant: primaryApplicant };
            }, stateCallback);
        }
    }, {
        key: 'executeGAVirtualPageView',
        value: function executeGAVirtualPageView(openFormIndex) {
            switch (openFormIndex) {
                case _financing.FORM_INDEX.PERSONAL_INFO:
                    _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.CHECKOUT_FINANCING_PERSONAL_INFO());
                    break;
                case _financing.FORM_INDEX.RESIDENCE_INFO:
                    _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.CHECKOUT_FINANCING_RESIDENCE_INFO());
                    break;
                case _financing.FORM_INDEX.EMPLOYMENT_INFO:
                    _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.CHECKOUT_FINANCING_EMPLOYMENT_INFO());
                    break;
                case _financing.FORM_INDEX.JOINT_INFO:
                    _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.CHECKOUT_FINANCING_JOINT_INFO());
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'nextForm',
        value: function nextForm() {
            var _this2 = this;

            this.setState(function (prevState) {
                return { openFormIndex: prevState.openFormIndex + 1 };
            }, function () {
                _this2.executeGAVirtualPageView(_this2.state.openFormIndex);
                _this2.props.onFormChange(_this2.state);
            });
        }
    }, {
        key: 'previousForm',
        value: function previousForm() {
            var _this3 = this;

            this.setState(function (prevState) {
                var primaryApplicant = prevState.primaryApplicant;

                var openFormIndex = prevState.openFormIndex - 1;
                var isInCoApplicantSection = openFormIndex >= 4;

                primaryApplicant.validations.joinApplicationDone = isInCoApplicantSection;

                return {
                    openFormIndex: openFormIndex,
                    hasCoApplicant: isInCoApplicantSection,
                    stepCount: isInCoApplicantSection ? 7 : 4,
                    primaryApplicant: primaryApplicant
                };
            }, function () {
                _this3.executeGAVirtualPageView(_this3.state.openFormIndex);
                _this3.props.onFormChange(_this3.state);
            });
        }
    }, {
        key: 'saveCreditApplication',
        value: function saveCreditApplication() {
            var _this4 = this;

            var creditApplication = {
                id: this.state.creditApplicationId,
                application: this.state
            };

            return Promise.all([_widgetCommonsVehicle.ShowroomService.saveCreditApplication(creditApplication), this.saveFinancing()]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 1),
                    showroomResult = _ref2[0];

                _this4.dispatchFinancingCreatedEvent();
                if (showroomResult.id !== _this4.state.creditApplicationId) {
                    _this4.setState({ creditApplicationId: showroomResult.id });
                }
            });
        }
    }, {
        key: 'saveFinancing',
        value: function saveFinancing() {
            var applicants = this.state.hasCoApplicant ? [this.state.primaryApplicant, this.state.coApplicant] : [this.state.primaryApplicant];

            var validity = (0, _lodash.reduce)(applicants, function (result, applicant) {
                return _widgetCommonsForms.ValidationService.validateForm(applicant.validations);
            }, false);

            if (validity) {
                var financing = _FinancingMapperService2.default.getFinancingApplicationFromState(this.state);
                _widgetCommonsGeneral.AnalyticsService.eventDataLayer('form|financing', 'submit', 'financing-showroom');
                return _FinancingService2.default.saveFinancing(financing, this.props.leadId).then(function (result) {
                    _widgetCommonsGeneral.ShiftDigitalService.createFormEvent(result.data.leadId, 'Financing | Showroom');
                });
            }
            return Promise.resolve();
        }
    }, {
        key: 'dispatchFinancingCreatedEvent',
        value: function dispatchFinancingCreatedEvent() {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.document.dispatchEvent(new Event(_widgetCommonsGeneral.EVENTS.FINANCING_CREATED));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _state = this.state,
                openFormIndex = _state.openFormIndex,
                hasCoApplicant = _state.hasCoApplicant,
                primaryApplicant = _state.primaryApplicant,
                coApplicant = _state.coApplicant,
                stepCount = _state.stepCount;

            var coApplicantForms = void 0;

            var forms = [_react2.default.createElement(_ApplicantInfosForm2.default, {
                key: 0,
                isOpen: openFormIndex === 0,
                onDone: function onDone(newInformations) {
                    return _this5.onDone(newInformations, false);
                },
                personalInformations: primaryApplicant.personalInformations
            }), _react2.default.createElement(_ResidenceInfosForm2.default, {
                key: 1,
                isOpen: openFormIndex === 1,
                onDone: function onDone(newInformations) {
                    return _this5.onDone(newInformations, false);
                },
                onBack: function onBack(newInformations) {
                    return _this5.onGoBack(newInformations, false);
                },
                residenceInformations: primaryApplicant.residenceInformations
            }), _react2.default.createElement(_EmploymentInfosForm2.default, {
                key: 2,
                isOpen: openFormIndex === 2,
                onDone: function onDone(newInformations) {
                    return _this5.onDone(newInformations, false);
                },
                onBack: function onBack(newInformations) {
                    return _this5.onGoBack(newInformations, false);
                }
            }), _react2.default.createElement(_JointInfosForm2.default, {
                key: 3,
                isOpen: openFormIndex === 3,
                onDone: this.onJointInfoOptionChange,
                onBack: this.previousForm,
                hasCoApplicant: hasCoApplicant
            })];

            if (hasCoApplicant) {
                coApplicantForms = [_react2.default.createElement(_ApplicantInfosForm2.default, {
                    key: 4,
                    isOpen: openFormIndex === 4,
                    onDone: function onDone(newInformations) {
                        return _this5.onDone(newInformations, true);
                    },
                    onBack: function onBack(newInformations) {
                        return _this5.onGoBack(newInformations, true);
                    },
                    personalInformations: coApplicant.personalInformations,
                    isCoApplicant: true
                }), _react2.default.createElement(_ResidenceInfosForm2.default, {
                    key: 5,
                    isOpen: openFormIndex === 5,
                    onDone: function onDone(newInformations) {
                        return _this5.onDone(newInformations, true);
                    },
                    onBack: function onBack(newInformations) {
                        return _this5.onGoBack(newInformations, true);
                    },
                    residenceInformations: coApplicant.residenceInformations,
                    isCoApplicant: true
                }), _react2.default.createElement(_EmploymentInfosForm2.default, {
                    key: 6,
                    isOpen: openFormIndex === 6,
                    onDone: function onDone(newInformations) {
                        return _this5.onDone(newInformations, true);
                    },
                    onBack: function onBack(newInformations) {
                        return _this5.onGoBack(newInformations, true);
                    },
                    isCoApplicant: true
                })];
            }

            var isAllFormsDone = openFormIndex >= stepCount;
            return _react2.default.createElement(
                'div',
                { className: 'financing__wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'financing__content sr-financing' },
                    forms,
                    coApplicantForms
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'financing__control' },
                    isAllFormsDone && _react2.default.createElement(
                        'button',
                        { onClick: function onClick() {
                                return _this5.previousForm();
                            }, type: 'button', className: 'sr-link' },
                        _widgetCommonsCoreServices.LocaleService.t('FINANCING.BACK')
                    ),
                    this.props.children
                )
            );
        }
    }]);

    return Financing;
}(_react2.default.Component);

Financing.defaultProps = {
    account: new _widgetCommonsGeneral.Account()
};

Financing.propTypes = {
    account: _propTypes2.default.instanceOf(_widgetCommonsGeneral.Account),
    leadId: _propTypes2.default.number.isRequired,
    onFormChange: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.node.isRequired
};

Financing.displayName = 'Financing';

function mapStateToProps(state) {
    return {
        account: state.account
    };
}

exports.Financing = Financing;
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Financing);

/***/ }),

/***/ "./src/components/Financing/Financing.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/FinancingForm/FinancingForm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _Financing = __webpack_require__("./src/components/Financing/Financing.jsx");

var _Financing2 = _interopRequireDefault(_Financing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FinancingForm = function (_React$Component) {
    _inherits(FinancingForm, _React$Component);

    function FinancingForm(props) {
        _classCallCheck(this, FinancingForm);

        var _this = _possibleConstructorReturn(this, (FinancingForm.__proto__ || Object.getPrototypeOf(FinancingForm)).call(this, props));

        _this.state = {
            isFinancingFormValid: false
        };

        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.onClickEvent = _this.onClickEvent.bind(_this);
        _this.onFormChange = _this.onFormChange.bind(_this);
        return _this;
    }

    _createClass(FinancingForm, [{
        key: 'onClickEvent',
        value: function onClickEvent() {
            if (this.state.isFinancingFormValid) {
                var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
                if (windowProxy) {
                    var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
                    windowProxy.location.href = _widgetCommonsGeneral.REDIRECTIONS[locale].thankyou;
                }
            }
        }
    }, {
        key: 'onFormChange',
        value: function onFormChange(form) {
            var applicants = form.hasCoApplicant ? [form.primaryApplicant, form.coApplicant] : [form.primaryApplicant];

            this.setState({
                isFinancingFormValid: (0, _lodash.reduce)(applicants, function (result, applicant) {
                    return _widgetCommonsForms.ValidationService.validateForm(applicant.validations);
                }, false)
            });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
        }
    }, {
        key: 'render',
        value: function render() {
            var buttonClass = ['sr-button-1 is-small'];
            if (!this.state.isFinancingFormValid) {
                buttonClass.push('is-disabled');
            }

            return _react2.default.createElement(
                'form',
                { onSubmit: this.handleSubmit },
                _react2.default.createElement(
                    _Financing2.default,
                    { onFormChange: this.onFormChange },
                    _react2.default.createElement(
                        'div',
                        { className: 'financing__content-btn-section' },
                        _react2.default.createElement(
                            'button',
                            { className: buttonClass.join(' '), type: 'submit', onClick: this.onClickEvent },
                            _widgetCommonsCoreServices.LocaleService.t('FINANCING.SUBMIT')
                        )
                    )
                )
            );
        }
    }]);

    return FinancingForm;
}(_react2.default.Component);

FinancingForm.propTypes = {};

FinancingForm.displayName = 'FinancingForm';

exports.default = FinancingForm;

/***/ }),

/***/ "./src/components/JointInfosForm/JointInfosForm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _ButtonBlock = __webpack_require__("./src/components/Utils/ButtonBlock.jsx");

var _ButtonBlock2 = _interopRequireDefault(_ButtonBlock);

__webpack_require__("./src/components/JointInfosForm/JointInfosForm.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JointInfosForm = function (_React$Component) {
    _inherits(JointInfosForm, _React$Component);

    function JointInfosForm(props) {
        _classCallCheck(this, JointInfosForm);

        var _this = _possibleConstructorReturn(this, (JointInfosForm.__proto__ || Object.getPrototypeOf(JointInfosForm)).call(this, props));

        _this.state = {
            coApplicantOptions: [{
                key: 0,
                isSelected: props.hasCoApplicant,
                label: _widgetCommonsCoreServices.LocaleService.t('FINANCING.JOINT_INFOS.YES'),
                option: true
            }, {
                key: 1,
                isSelected: !props.hasCoApplicant,
                label: _widgetCommonsCoreServices.LocaleService.t('FINANCING.JOINT_INFOS.NO'),
                option: false
            }],
            hasCoApplicant: props.hasCoApplicant,
            isValid: false
        };

        _this.onDone = _this.onDone.bind(_this);
        _this.onCoApplicationOptionChange = _this.onCoApplicationOptionChange.bind(_this);
        return _this;
    }

    _createClass(JointInfosForm, [{
        key: 'onCoApplicationOptionChange',
        value: function onCoApplicationOptionChange(newValue) {
            this.setState(function (oldState) {
                var coApplicantOptions = oldState.coApplicantOptions;

                return {
                    hasCoApplicant: newValue,
                    coApplicantOptions: coApplicantOptions.map(function (option) {
                        option.isSelected = newValue === option.option;
                        return option;
                    })
                };
            });
        }
    }, {
        key: 'onDone',
        value: function onDone() {
            this.setState({
                isValid: true
            });
            this.props.onDone(this.state.hasCoApplicant);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isOpen = this.props.isOpen;
            var isValid = this.state.isValid;


            var buttons = this.state.coApplicantOptions.map(function (coApplicantOption) {
                var isChecked = coApplicantOption.isSelected;
                return _react2.default.createElement(
                    'div',
                    { className: 'radio-button-cta-wrapper--single', key: coApplicantOption.key },
                    _react2.default.createElement('input', {
                        type: 'radio',
                        id: coApplicantOption.key,
                        name: 'genderOption',
                        value: 'coApplicant',
                        onChange: function onChange() {
                            return _this2.onCoApplicationOptionChange(coApplicantOption.option);
                        },
                        checked: isChecked
                    }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: coApplicantOption.key },
                        coApplicantOption.label
                    )
                );
            });

            var coApplicantForm = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'radio-button-cta-wrapper' },
                    buttons
                ),
                _react2.default.createElement(_ButtonBlock2.default, { onBack: this.props.onBack, onDone: this.onDone })
            );

            var formClass = isOpen ? 'financingBlockForm coApplicantForm is-open' : 'financingBlockForm coApplicantForm is-closed ' + (isValid ? 'is-valid' : '');

            return _react2.default.createElement(
                'div',
                { className: formClass },
                _react2.default.createElement('icon', { className: 'icon-Crochet is-util' }),
                _react2.default.createElement(
                    'h3',
                    { className: 'sr-text is-bold is-util' },
                    _widgetCommonsCoreServices.LocaleService.t('FINANCING.JOINT_INFOS.JOINT_APPLICATION')
                ),
                isOpen && coApplicantForm
            );
        }
    }]);

    return JointInfosForm;
}(_react2.default.Component);

JointInfosForm.defaultProps = {
    isOpen: true
};

JointInfosForm.propTypes = {
    hasCoApplicant: _propTypes2.default.bool.isRequired,
    isOpen: _propTypes2.default.bool,
    onBack: _propTypes2.default.func.isRequired,
    onDone: _propTypes2.default.func.isRequired
};

JointInfosForm.displayName = 'JointInfosForm';

exports.default = JointInfosForm;

/***/ }),

/***/ "./src/components/JointInfosForm/JointInfosForm.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/ResidenceInfosForm/AddressDisplay.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _localization = __webpack_require__("./src/constants/localization.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressDisplay = function AddressDisplay(_ref) {
    var address = _ref.address,
        address2 = _ref.address2,
        city = _ref.city,
        country = _ref.country,
        postalCode = _ref.postalCode,
        province = _ref.province;

    var provinceTransKey = '';
    if (province) {
        provinceTransKey = (0, _lodash.find)(_localization.PROVINCES, function (i) {
            return i.value === province.toLowerCase();
        }).transKey;
    }
    return _react2.default.createElement(
        'div',
        { className: 'personalInfo' },
        _react2.default.createElement(
            'span',
            null,
            !(0, _lodash.isEmpty)(address) && address,
            !(0, _lodash.isEmpty)(address2) && ' ' + address2 + ','
        ),
        _react2.default.createElement(
            'span',
            null,
            !(0, _lodash.isEmpty)(city) && city
        ),
        _react2.default.createElement(
            'span',
            null,
            !(0, _lodash.isEmpty)(province) && _widgetCommonsCoreServices.LocaleService.t(provinceTransKey),
            !(0, _lodash.isEmpty)(country) && ' ' + country + ','
        ),
        _react2.default.createElement(
            'span',
            null,
            !(0, _lodash.isEmpty)(postalCode) && postalCode
        )
    );
};

AddressDisplay.propTypes = {
    address: _propTypes2.default.string.isRequired,
    address2: _propTypes2.default.string.isRequired,
    city: _propTypes2.default.string.isRequired,
    country: _propTypes2.default.string.isRequired,
    postalCode: _propTypes2.default.string.isRequired,
    province: _propTypes2.default.string.isRequired
};

AddressDisplay.displayName = 'AddressDisplay';

exports.default = AddressDisplay;

/***/ }),

/***/ "./src/components/ResidenceInfosForm/ResidenceInfosForm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _housing = __webpack_require__("./src/constants/housing.js");

var _localization = __webpack_require__("./src/constants/localization.js");

var _ErrorService = __webpack_require__("./src/services/ErrorService/ErrorService.js");

var _ErrorService2 = _interopRequireDefault(_ErrorService);

var _residenceFormConfig = __webpack_require__("./src/components/ResidenceInfosForm/residenceFormConfig.js");

var _residenceFormConfig2 = _interopRequireDefault(_residenceFormConfig);

var _AddressDisplay = __webpack_require__("./src/components/ResidenceInfosForm/AddressDisplay.jsx");

var _AddressDisplay2 = _interopRequireDefault(_AddressDisplay);

var _ButtonBlock = __webpack_require__("./src/components/Utils/ButtonBlock.jsx");

var _ButtonBlock2 = _interopRequireDefault(_ButtonBlock);

var _FormBuilder = __webpack_require__("./src/components/Utils/FormBuilder.jsx");

var _FormBuilder2 = _interopRequireDefault(_FormBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResidenceInfosForm = function (_React$Component) {
    _inherits(ResidenceInfosForm, _React$Component);

    function ResidenceInfosForm(props) {
        _classCallCheck(this, ResidenceInfosForm);

        var _this = _possibleConstructorReturn(this, (ResidenceInfosForm.__proto__ || Object.getPrototypeOf(ResidenceInfosForm)).call(this, props));

        _this.state = {
            isSubmitted: false,
            isValid: false,
            inputs: _extends({}, props.residenceInformations, {
                monthCount: '',
                yearCount: ''
            }),
            formValidation: {
                currentAddress: false,
                monthCount: false,
                yearCount: false,
                housingType: false
            },
            housingType: props.residenceInformations.housingType || '',
            housingValidation: {},
            errors: []
        };

        _this.state.editModeCurrentAddress = !(_this.state.address && _this.state.postalCode && _this.state.city);

        _this.onAddressChange = _this.onAddressChange.bind(_this);
        _this.onBack = _this.onBack.bind(_this);
        _this.onDone = _this.onDone.bind(_this);
        _this.onDurationChange = _this.onDurationChange.bind(_this);
        _this.onEditAddressClick = _this.onEditAddressClick.bind(_this);
        _this.onHousingTypeChanged = _this.onHousingTypeChanged.bind(_this);
        _this.onHousingValueChange = _this.onHousingValueChange.bind(_this);
        return _this;
    }

    _createClass(ResidenceInfosForm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var formValidation = this.state.formValidation;
            var address = this.state.inputs.address;


            var asAllAddressInfos = this.isAddressComplete(address);

            this.setState({
                editModeCurrentAddress: !asAllAddressInfos,
                formValidation: _extends({}, formValidation, {
                    currentAddress: true
                })
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.provinces = _localization.PROVINCES.map(function (province) {
                return _extends({}, province, {
                    label: _widgetCommonsCoreServices.LocaleService.t(province.transKey)
                });
            });

            this.homeStatuses = _housing.HOME_STATUSES.map(function (status) {
                return _extends({}, status, {
                    label: _widgetCommonsCoreServices.LocaleService.t(status.transKey)
                });
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            var newAddress = newProps.residenceInformations.address;
            if (newAddress) {
                this.setState({
                    inputs: _extends({}, this.state.inputs, {
                        address: _extends({}, newAddress)
                    }),
                    editModeCurrentAddress: !this.isAddressComplete(newAddress)
                });
            }
        }
    }, {
        key: 'onDone',
        value: function onDone(callbackObject) {
            var _state = this.state,
                housingValidation = _state.housingValidation,
                formValidation = _state.formValidation;


            var errors = _ErrorService2.default.getErrors(formValidation, 'FINANCING.RESIDENCE_INFOS.ERRORS');

            if (!(0, _lodash.every)(housingValidation, function (validation) {
                return validation;
            })) {
                errors.push({
                    code: 'error.housingOptions',
                    message: _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.ERRORS.HOUSING_OPTIONS')
                });
            }

            this.setState({
                errors: errors,
                isSubmitted: true,
                isValid: !errors.length
            });

            this.props.onDone(_widgetCommonsForms.GroupResponseService.createResponse(!errors.length, callbackObject, null, null, 'residenceInformations'));
        }
    }, {
        key: 'onBack',
        value: function onBack(callbackObject) {
            this.props.onBack(_widgetCommonsForms.GroupResponseService.createResponse(true, callbackObject, null, null, 'residenceInformations'));
        }
    }, {
        key: 'onHousingTypeChanged',
        value: function onHousingTypeChanged(newValue) {
            var valueIsValid = newValue && newValue !== '';

            this.setState(function (oldState) {
                var formValidation = oldState.formValidation;


                formValidation.housingType = valueIsValid;

                var validationFields = {};
                (0, _lodash.each)(_residenceFormConfig2.default[newValue.value], function (input) {
                    validationFields[input.inputName] = !input.isRequired;
                });

                return {
                    formValidation: formValidation,
                    housingType: newValue.value,
                    housingValues: {},
                    housingValidation: validationFields
                };
            });
        }
    }, {
        key: 'onEditAddressClick',
        value: function onEditAddressClick() {
            this.setState({ editModeCurrentAddress: true });
        }
    }, {
        key: 'onDurationChange',
        value: function onDurationChange(newValue, inputName) {
            if (newValue === '' || parseInt(newValue, 10) < 0) {
                this.setState(function (oldState) {
                    var inputs = oldState.inputs,
                        formValidation = oldState.formValidation;

                    formValidation[inputName] = false;
                    inputs[inputName] = newValue === '' ? '' : 0;
                    return { inputs: inputs, formValidation: formValidation };
                });
                return;
            }

            var parsedValue = parseInt(newValue, 10);
            // eslint-disable-next-line no-restricted-globals
            var validatedValue = isFinite(newValue) ? parsedValue : 0;

            if (inputName === 'yearCount') {
                this.setState(function (oldState) {
                    var inputs = oldState.inputs,
                        formValidation = oldState.formValidation;

                    inputs.yearCount = validatedValue;
                    formValidation.yearCount = true;
                    return { inputs: inputs, formValidation: formValidation };
                });
            } else if (inputName === 'monthCount') {
                this.setState(function (oldState) {
                    var inputs = oldState.inputs,
                        formValidation = oldState.formValidation;
                    var yearCount = inputs.yearCount;

                    var monthCount = validatedValue;

                    if (validatedValue > 12) {
                        yearCount += Math.floor(validatedValue / 12);
                        monthCount = validatedValue % 12;
                    }

                    inputs.yearCount = yearCount;
                    inputs.monthCount = monthCount;
                    formValidation.yearCount = true;
                    formValidation.monthCount = true;
                    return { inputs: inputs, formValidation: formValidation };
                });
            }
        }
    }, {
        key: 'onHousingValueChange',
        value: function onHousingValueChange(newValue, inputName, isValid) {
            this.setState(function (oldState) {
                var housingValues = oldState.housingValues,
                    housingValidation = oldState.housingValidation;


                housingValues[inputName] = newValue;
                housingValidation[inputName] = isValid;

                return { housingValues: housingValues, housingValidation: housingValidation };
            });
        }
    }, {
        key: 'onAddressChange',
        value: function onAddressChange(result) {
            this.setState(function (oldState) {
                var formValidation = oldState.formValidation,
                    inputs = oldState.inputs;


                formValidation.currentAddress = result.valid;
                inputs.address = result.value || oldState.inputs.address;

                return {
                    formValidation: formValidation,
                    inputs: inputs
                };
            });
        }
    }, {
        key: 'isAddressComplete',
        value: function isAddressComplete(receivedAddress) {
            var address = receivedAddress || this.state.inputs.address;
            if (!address) {
                return false;
            }
            return !!address.address && !!address.postalCode && !!address.city && !!address.province;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isOpen = this.props.isOpen;
            var _state2 = this.state,
                editModeCurrentAddress = _state2.editModeCurrentAddress,
                errors = _state2.errors,
                formValidation = _state2.formValidation,
                housingType = _state2.housingType,
                housingValues = _state2.housingValues,
                housingValidation = _state2.housingValidation,
                inputs = _state2.inputs,
                isSubmitted = _state2.isSubmitted,
                isValid = _state2.isValid;


            var addressLabels = {
                address: _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.ADDRESS.ADDRESS'),
                address2: _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.ADDRESS.ADDRESS2'),
                city: _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.ADDRESS.CITY'),
                postalCode: _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.ADDRESS.POSTAL_CODE'),
                province: _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.ADDRESS.PROVINCE')
            };

            var callbackObject = {
                inputs: inputs,
                housingType: housingType || '',
                housingValues: housingValues
            };

            var currentAddressForm = _react2.default.createElement(
                'div',
                { className: 'addressBlock clearfix' },
                _react2.default.createElement(_widgetCommonsForms.Groups.AddressGroup, {
                    values: inputs.address,
                    labels: addressLabels,
                    onChange: this.onAddressChange,
                    provinces: this.provinces,
                    hasBeenSubmit: isSubmitted
                })
            );

            var housingFormBlock = null;
            if (housingType) {
                housingFormBlock = _residenceFormConfig2.default[housingType].map(function (input) {
                    return _react2.default.createElement(_FormBuilder2.default, {
                        key: input.inputName,
                        inputParams: _extends({}, input, { value: housingValues[input.inputName] }),
                        onChange: _this2.onHousingValueChange,
                        hasBeenSubmit: isSubmitted,
                        isValid: housingValidation[input.inputName],
                        errorLabel: input.errorTransKey
                    });
                });
            }

            var residenceForm = _react2.default.createElement(
                'div',
                { className: 'clearfix' },
                _react2.default.createElement(
                    'h4',
                    { className: 'sr-text is-bold' },
                    this.props.isCoApplicant ? _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.CURRENT_ADDRESS') : _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.MY_CURRENT_ADDRESS')
                ),
                _react2.default.createElement('br', null),
                !editModeCurrentAddress ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_AddressDisplay2.default, inputs.address),
                    _react2.default.createElement(
                        'button',
                        { className: 'sr-link', onClick: this.onEditAddressClick },
                        _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.EDIT_CURRENT_ADDRESS'),
                        ' >'
                    )
                ) : currentAddressForm,
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    _react2.default.createElement(_widgetCommonsForms.InputText, {
                        label: _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.YEAR_COUNT'),
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.YEAR_COUNT'),
                        name: 'yearCount',
                        type: 'number',
                        value: inputs.yearCount,
                        classNames: ['styled-placeholder', 'quarter'],
                        isValid: formValidation.yearCount,
                        isRequired: true,
                        valueChange: this.onDurationChange,
                        hasBeenSubmit: isSubmitted,
                        maxLength: _widgetCommonsForms.FIELD_LENGTH.DEFAULT_NUMBER_MAX
                    }),
                    _react2.default.createElement(_widgetCommonsForms.InputText, {
                        label: _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.MONTH_COUNT'),
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTH_COUNT'),
                        name: 'monthCount',
                        type: 'number',
                        value: inputs.monthCount,
                        classNames: ['styled-placeholder', 'quarter'],
                        isValid: formValidation.monthCount,
                        isRequired: true,
                        valueChange: this.onDurationChange,
                        hasBeenSubmit: isSubmitted,
                        maxLength: _widgetCommonsForms.FIELD_LENGTH.DEFAULT_NUMBER_MAX
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'sr-text is-bold' },
                        _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.HOUSING')
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                        name: 'homeStatus',
                        options: this.homeStatuses,
                        value: housingType,
                        valueChange: this.onHousingTypeChanged,
                        placeholder: _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.HOME_STATUS'),
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.HOME_STATUS'),
                        classNames: ['half'],
                        isValid: formValidation.housingType,
                        hasBeenSubmit: isSubmitted,
                        isRequired: true
                    }),
                    housingFormBlock
                ),
                errors.length !== 0 && isSubmitted && isOpen && _react2.default.createElement(
                    'p',
                    { className: 'financing__content-errors-message' },
                    _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.TITLE')
                ),
                _react2.default.createElement(_ButtonBlock2.default, { onBack: function onBack() {
                        return _this2.onBack(callbackObject);
                    }, onDone: function onDone() {
                        return _this2.onDone(callbackObject);
                    } })
            );

            var formClass = isOpen ? 'financingBlockForm residenceForm is-open' : 'financingBlockForm residenceForm is-closed ' + (isValid ? 'is-valid' : '');

            return _react2.default.createElement(
                'div',
                { className: formClass },
                _react2.default.createElement('icon', { className: 'icon-Crochet is-util' }),
                errors.length !== 0 && isSubmitted && isOpen && _react2.default.createElement(_widgetCommonsForms.ErrorsHandler, { errors: errors }),
                _react2.default.createElement(
                    'h3',
                    { className: 'sr-text is-bold is-util' },
                    this.props.isCoApplicant ? _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.TELL_US_MORE_COAPPLICANT') : _widgetCommonsCoreServices.LocaleService.t('FINANCING.RESIDENCE_INFOS.TELL_US_MORE')
                ),
                _react2.default.createElement('br', null),
                isOpen ? residenceForm : _react2.default.createElement(_AddressDisplay2.default, inputs.address)
            );
        }
    }]);

    return ResidenceInfosForm;
}(_react2.default.Component);

ResidenceInfosForm.defaultProps = {
    isOpen: true,
    isCoApplicant: false
};

ResidenceInfosForm.propTypes = {
    isOpen: _propTypes2.default.bool,
    isCoApplicant: _propTypes2.default.bool,
    residenceInformations: _propTypes2.default.shape({
        address: _propTypes2.default.shape({
            address: _propTypes2.default.string.isRequired,
            address2: _propTypes2.default.string.isRequired,
            postalCode: _propTypes2.default.string.isRequired,
            city: _propTypes2.default.string.isRequired,
            province: _propTypes2.default.string.isRequired
        }),
        housingType: _propTypes2.default.string,
        housingValues: _propTypes2.default.object
    }).isRequired,
    onDone: _propTypes2.default.func.isRequired,
    onBack: _propTypes2.default.func.isRequired
};

ResidenceInfosForm.displayName = 'ResidenceInfosForm';

exports.default = ResidenceInfosForm;

/***/ }),

/***/ "./src/components/ResidenceInfosForm/residenceFormConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var residenceFormConfig = {
    OwnFreeAndClear: [],
    OwnMobileHome: [{
        inputName: 'monthlypayments',
        transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        inputType: 'number',
        isRequired: true,
        classNames: 'half'
    }],
    Other: [{
        inputName: 'monthlypayments',
        transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        inputType: 'number',
        isRequired: true,
        classNames: 'half'
    }, {
        inputName: 'additionalInfos',
        transKey: 'FINANCING.RESIDENCE_INFOS.ADDITIONAL_INFOS',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.ADDITIONAL_INFOS',
        inputType: 'text',
        isRequired: false,
        classNames: 'full'
    }],
    OwnWithMortage: [{
        inputName: 'monthlypayments',
        transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        inputType: 'number',
        isRequired: true,
        classNames: 'half'
    }, {
        inputName: 'mortgageAmount',
        transKey: 'FINANCING.RESIDENCE_INFOS.MORTGAGE_AMOUNT',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MORTGAGE_AMOUNT',
        inputType: 'number',
        isRequired: true,
        classNames: 'half'
    }, {
        inputName: 'mortgageValue',
        transKey: 'FINANCING.RESIDENCE_INFOS.MORTGAGE_VALUE',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MORTGAGE_VALUE',
        inputType: 'number',
        isRequired: true,
        classNames: 'half'
    }, {
        inputName: 'mortgageHolder',
        transKey: 'FINANCING.RESIDENCE_INFOS.MORTGAGE_HOLDER',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MORTGAGE_HOLDER',
        inputType: 'text',
        isRequired: true,
        classNames: 'full'
    }],
    Parents: [{
        inputName: 'monthlypayments',
        transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        inputType: 'number',
        isRequired: true,
        classNames: 'half'
    }],
    Rent: [{
        inputName: 'monthlypayments',
        transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        inputType: 'number',
        isRequired: true,
        classNames: 'half'
    }, {
        inputName: 'landlord',
        transKey: 'FINANCING.RESIDENCE_INFOS.LANDLORD',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.LANDLORD',
        inputType: 'text',
        isRequired: true,
        classNames: 'full'
    }],
    ReserveHousing: [{
        inputName: 'monthlypayments',
        transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
        inputType: 'number',
        isRequired: true,
        classNames: 'half'
    }]
};

exports.default = residenceFormConfig;

/***/ }),

/***/ "./src/components/Utils/ButtonBlock.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonBlock = function ButtonBlock(_ref) {
    var formIsValid = _ref.formIsValid,
        onBack = _ref.onBack,
        onDone = _ref.onDone;

    return _react2.default.createElement(
        'div',
        { className: 'financing__content-btn-section' },
        onBack && _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                    return onBack();
                }, disabled: !formIsValid, type: 'button', className: 'sr-link' },
            _widgetCommonsCoreServices.LocaleService.t('FINANCING.BACK')
        ),
        onDone && _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                    return onDone();
                }, disabled: !formIsValid, className: 'sr-button-1 is-small' },
            _widgetCommonsCoreServices.LocaleService.t('FINANCING.DONE')
        )
    );
};

ButtonBlock.defaultProps = {
    formIsValid: true,
    onBack: null,
    onDone: null
};

ButtonBlock.propTypes = {
    formIsValid: _propTypes2.default.bool,
    onBack: _propTypes2.default.func,
    onDone: _propTypes2.default.func
};

ButtonBlock.displayName = 'ButtonBlock';

exports.default = ButtonBlock;

/***/ }),

/***/ "./src/components/Utils/FormBuilder.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormBuilder = function (_React$Component) {
    _inherits(FormBuilder, _React$Component);

    function FormBuilder(props) {
        _classCallCheck(this, FormBuilder);

        var _this = _possibleConstructorReturn(this, (FormBuilder.__proto__ || Object.getPrototypeOf(FormBuilder)).call(this, props));

        var inputParams = _this.props.inputParams;


        _this.state = {
            isValid: inputParams.isRequired ? !!inputParams.value : true,
            value: props.inputParams.value
        };

        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(FormBuilder, [{
        key: 'onChange',
        value: function onChange(newValue, inputName) {
            var _props = this.props,
                inputParams = _props.inputParams,
                onChange = _props.onChange;

            var isValid = !inputParams.isRequired || !!newValue;

            this.setState({
                isValid: isValid,
                value: newValue
            });

            onChange(newValue, inputName, isValid);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                inputParams = _props2.inputParams,
                hasBeenSubmit = _props2.hasBeenSubmit,
                errorLabel = _props2.errorLabel;
            var _state = this.state,
                isValid = _state.isValid,
                value = _state.value;


            var options = [];
            if ((0, _lodash.has)(inputParams, 'options')) {
                options = inputParams.options.map(function (option) {
                    return _extends({}, option, {
                        label: _widgetCommonsCoreServices.LocaleService.t(option.transKey)
                    });
                });
            }

            var classNames = ['styled-placeholder', '' + inputParams.classNames];

            switch (inputParams.inputType) {
                case 'phone':
                    return _react2.default.createElement(_widgetCommonsForms.InputPhoneNumber, {
                        label: _widgetCommonsCoreServices.LocaleService.t(inputParams.transKey),
                        name: inputParams.inputName,
                        type: 'phone',
                        classNames: classNames,
                        isRequired: inputParams.isRequired,
                        valueChange: function valueChange(changedValue) {
                            return _this2.onChange(changedValue.value, changedValue.name, changedValue.validation);
                        },
                        value: value,
                        isValid: isValid,
                        hasBeenSubmit: hasBeenSubmit,
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t(errorLabel)
                    });
                case 'postalCode':
                    return _react2.default.createElement(_widgetCommonsForms.InputZipCode, {
                        classNames: classNames,
                        label: _widgetCommonsCoreServices.LocaleService.t(inputParams.transKey),
                        value: value,
                        isValid: isValid,
                        isRequired: inputParams.isRequired,
                        hasBeenSubmit: hasBeenSubmit,
                        onChange: function onChange(changedValue) {
                            return _this2.onChange(changedValue.value, inputParams.inputName, changedValue.validation);
                        },
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t(errorLabel)
                    });
                case 'email':
                    return _react2.default.createElement(_widgetCommonsForms.InputEmail, {
                        label: _widgetCommonsCoreServices.LocaleService.t(inputParams.transKey),
                        classNames: classNames,
                        isRequired: inputParams.isRequired,
                        valueChange: this.onChange,
                        value: value,
                        hasBeenSubmit: hasBeenSubmit,
                        isValid: isValid,
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t(errorLabel)
                    });
                case 'dropdown':
                    return _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                        options: options,
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t(errorLabel),
                        placeholder: _widgetCommonsCoreServices.LocaleService.t(inputParams.transKey),
                        name: inputParams.inputName,
                        classNames: ['input-dropdown'].concat(inputParams.classNames),
                        isRequired: inputParams.isRequired,
                        valueChange: function valueChange(changedValue) {
                            return _this2.onChange(changedValue.value, inputParams.inputName, true);
                        },
                        value: value,
                        hasBeenSubmit: hasBeenSubmit,
                        isValid: isValid
                    });
                case 'subhead':
                    return _react2.default.createElement(
                        'div',
                        { className: 'clearfix' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'sr-text is-bold' },
                            _widgetCommonsCoreServices.LocaleService.t(inputParams.transKey)
                        )
                    );
                default:
                    return _react2.default.createElement(_widgetCommonsForms.InputText, {
                        label: _widgetCommonsCoreServices.LocaleService.t(inputParams.transKey),
                        errorLabel: _widgetCommonsCoreServices.LocaleService.t(errorLabel),
                        name: inputParams.inputName,
                        type: inputParams.inputType,
                        classNames: classNames,
                        isRequired: inputParams.isRequired,
                        valueChange: this.onChange,
                        value: value,
                        hasBeenSubmit: hasBeenSubmit,
                        isValid: isValid
                    });
            }
        }
    }]);

    return FormBuilder;
}(_react2.default.Component);

FormBuilder.defaultProps = {
    onChange: _lodash.noop
};

FormBuilder.propTypes = {
    inputParams: _propTypes2.default.shape({
        inputName: _propTypes2.default.string,
        transKey: _propTypes2.default.string.isRequired,
        inputType: _propTypes2.default.string.isRequired,
        classNames: _propTypes2.default.string,
        isRequired: _propTypes2.default.bool,
        options: _propTypes2.default,
        value: _propTypes2.default,
        placeholder: _propTypes2.default
    }).isRequired,
    onChange: _propTypes2.default.func,
    hasBeenSubmit: _propTypes2.default.bool,
    errorLabel: _propTypes2.default.string
};

FormBuilder.defaultProps = {
    onChange: _lodash.noop,
    hasBeenSubmit: false,
    errorLabel: ''
};

FormBuilder.displayName = 'FormBuilder';

exports.default = FormBuilder;

/***/ }),

/***/ "./src/config/dev.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://service.backbones.widget-supplier.dev.office.n360.io","account":"https://service.backbones.account.dev.office.n360.io/api","showroom":"https://dev-api.showroom360.ca:9443","graphql":"https://service.backbones.webauto-supplier.dev.office.n360.io/webauto/graphql"},"source":{"image":"http://img-dev.sm360.ca","widget":"https://s3.amazonaws.com/widgets-dev-cdn/financing"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-dev-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-dev-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/config/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dev = __webpack_require__("./src/config/dev.json");

var _dev2 = _interopRequireDefault(_dev);

var _int = __webpack_require__("./src/config/int.json");

var _int2 = _interopRequireDefault(_int);

var _local = __webpack_require__("./src/config/local.json");

var _local2 = _interopRequireDefault(_local);

var _prod = __webpack_require__("./src/config/prod.json");

var _prod2 = _interopRequireDefault(_prod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {};

if (true) {
    config = _prod2.default;
} else if (process.env.BUILD_ENV === 'development') {
    config = _dev2.default;
} else if (process.env.BUILD_ENV === 'integration') {
    config = _int2.default;
} else {
    config = _local2.default;
}

exports.default = _extends({}, config);

/***/ }),

/***/ "./src/config/int.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://s3.amazonaws.com/widgets-int-cdn/financing"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/config/local.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-api-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"http://localhost:3360/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/config/prod.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget.sm360.ca","account":"https://account.sm360.ca/api","showroom":"https://api.showroom360.ca","graphql":"https://webauto-supplier-api.sm360.ca/webauto/graphql"},"source":{"image":"https://img.sm360.ca","widget":"https://s3.amazonaws.com/widgets-cdn/financing"},"secureCookies":true,"sentry":{"url":"","sentryLevel":"WARNING","consoleLevel":"ERROR","whitelistUrls":["^.*(widgets-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/constants/employment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var EMPLOYMENT_TYPES = [{
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.UNEMPLOYED',
    value: 'unemployed'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.RETIRED',
    value: 'retired'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.EMPLOYED',
    value: 'employed'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.SELF_EMPLOYED',
    value: 'selfEmployed'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.STUDENT',
    value: 'student'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.OTHER',
    value: 'other'
}];

var EMPLOYMENT_STATUS = [{
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.FULL_TIME',
    value: 'FT'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.FULL_TIME_PROBATION',
    value: 'FTP'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.PART_TIME_CASUAL',
    value: 'PTC'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.PART_TIME_REGULAR',
    value: 'PTR'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.RETIRED',
    value: 'RET'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.SELF_EMPLOYED',
    value: 'SE'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.SEASONAL_SUMMER',
    value: 'SEAS'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.SEASONAL_WINTER',
    value: 'SEAW'
}];

var FINANCING_FREQUENCIES = [{
    transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOME_FREQUENCIES.YEARLY',
    value: '1'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOME_FREQUENCIES.MONTHLY',
    value: '12'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOME_FREQUENCIES.WEEKLY',
    value: '52'
}];

exports.EMPLOYMENT_TYPES = EMPLOYMENT_TYPES;
exports.EMPLOYMENT_STATUS = EMPLOYMENT_STATUS;
exports.FINANCING_FREQUENCIES = FINANCING_FREQUENCIES;
exports.default = {
    EMPLOYMENT_TYPES: EMPLOYMENT_TYPES,
    EMPLOYMENT_STATUS: EMPLOYMENT_STATUS,
    FINANCING_FREQUENCIES: FINANCING_FREQUENCIES
};

/***/ }),

/***/ "./src/constants/financing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FORM_INDEX = {
    PERSONAL_INFO: 0,
    RESIDENCE_INFO: 1,
    EMPLOYMENT_INFO: 2,
    JOINT_INFO: 3
};

exports.FORM_INDEX = FORM_INDEX;
exports.default = { FORM_INDEX: FORM_INDEX };

/***/ }),

/***/ "./src/constants/housing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HOME_STATUSES = exports.HOME_STATUSES = [{
    transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.OWN_FREE_AND_CLEAR',
    value: 'OwnFreeAndClear'
}, {
    transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.OWN_MOBILE_HOME',
    value: 'OwnMobileHome'
}, {
    transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.OTHER',
    value: 'Other'
}, {
    transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.OWN_WITH_MORTAGE',
    value: 'OwnWithMortage'
}, {
    transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.PARENTS',
    value: 'Parents'
}, {
    transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.RENT',
    value: 'Rent'
}, {
    transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.RESERVE_HOUSING',
    value: 'ReserveHousing'
}];

exports.default = {
    HOME_STATUSES: HOME_STATUSES
};

/***/ }),

/***/ "./src/constants/incomes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var EXTERNAL_INCOMES = exports.EXTERNAL_INCOMES = [{
    transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.CAR_ALLOWANCE',
    value: 'carAllowance'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.CHILD_SUPPORT_ALIMONY',
    value: 'childSupportAlimony'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.DISABILITY_PAYMENTS',
    value: 'disabilityPayments'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.INVESTMENT_INCOME',
    value: 'investmentIncome'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.PENSIONS',
    value: 'pensions'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.RENTAL_INCOME',
    value: 'rentalIncome'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.WORKERS_COMPENSATION',
    value: 'workersCompensation'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.OTHER',
    value: 'other'
}];

exports.default = {
    EXTERNAL_INCOMES: EXTERNAL_INCOMES
};

/***/ }),

/***/ "./src/constants/localization.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PROVINCES = [{
    value: 'ab',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.ALBERTA'
}, {
    value: 'bc',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.BRITISH_COLUMBIA'
}, {
    value: 'mb',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.MANITOBA'
}, {
    value: 'nb',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.NEW_BRUNSWICK'
}, {
    value: 'nl',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.NEW_FOUNDLAND'
}, {
    value: 'ns',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.NOVA_SCOTIA'
}, {
    value: 'on',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.ONTARIO'
}, {
    value: 'pe',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.PRINCE_EDWARD'
}, {
    value: 'qc',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.QUEBEC'
}, {
    value: 'sk',
    transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.SASKATCHEWAN'
}];

var STREET_TYPES = [{
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.ALLEY',
    value: 'AL'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.AVENUE',
    value: 'AV'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.BOULEVARD',
    value: 'BV'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.MOUNT',
    value: 'MO'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.PATH',
    value: 'PA'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.PATHWAY',
    value: 'PW'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.PARKWAY',
    value: 'PY'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.PLACE',
    value: 'PL'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.ROAD',
    value: 'RD'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.STREET',
    value: 'ST'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.TRAIL',
    value: 'TR'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.WAY',
    value: 'WY'
}, {
    transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.OTHER',
    value: 'OT'
}];

exports.STREET_TYPES = STREET_TYPES;
exports.PROVINCES = PROVINCES;
exports.default = {
    STREET_TYPES: STREET_TYPES,
    PROVINCES: PROVINCES
};

/***/ }),

/***/ "./src/constants/profile.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GENDERS = {
    MALE: 1,
    FEMALE: 2
};

exports.GENDERS = GENDERS;
exports.default = { GENDERS: GENDERS };

/***/ }),

/***/ "./src/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"FINANCING":{"DEPOSIT":{"CONGRATS":"Congrats!","TITLE":"Your $%{amount} Deposit Has Been Received Successfully","SUBTITLE":"Now Let’s Finalize Your Purchase."},"APPLICANT_INFO":{"DATE_OF_BIRTH":"Birth Date","DAY":"Day","EDIT_PRIMARY_APPLICANT":"Edit the Primary Applicant","EDIT_COAPPLICANT":"Edit the Co-Applicant","FEMALE":"Female","FIRST_NAME":"First Name","LAST_NAME":"Last Name","PHONE_NUMBER":"Phone Number","EMAIL":"Email","GENDER":"Gender","MALE":"Male","MONTH":"Month","YEAR":"Year","WHO_IS_PRIMARY_APPLICANT":"Who Is the Primary Applicant","WHO_IS_COAPPLICANT":"Who Is the Co-Applicant","ERRORS":{"IDENTITY":"The identity is invalid","GENDER":"The gender is invalid","DATE_OF_BIRTH":"The birth date is invalid"}},"BACK":"Back","DONE":"Continue","SUBMIT":"Submit My Informations","RESIDENCE_INFOS":{"ADDRESS":{"ADDRESS":"Address","ADDRESS2":"Address line 2","POSTAL_CODE":"Postal Code","CITY":"City","PROVINCE":"Province"},"MY_CURRENT_ADDRESS":"My Current Address","CURRENT_ADDRESS":"Current Address","EDIT_MY_CURRENT_ADDRESS":"Edit My Current Address","EDIT_CURRENT_ADDRESS":"Edit Current Address","HOME_STATUS":"Your Ownership Status","HOME_STATUS_TYPE":{"OWN_FREE_AND_CLEAR":"Own Free and Clear","OWN_MOBILE_HOME":"Own Mobile Home","OTHER":"Other","OWN_WITH_MORTAGE":"Own With Mortage","PARENTS":"Parents","RENT":"Rent","RESERVE_HOUSING":"Reserve Housing"},"HOUSING":"Housing","MONTH_COUNT":"Months at Address","TELL_US_MORE":"Tell Us More About Your Residence","TELL_US_MORE_COAPPLICANT":"Tell Us More About The Co-Applicant Residence","YEAR_COUNT":"Years at Address","MONTHLY_PAYMENTS":"Monthly Payments","ADDITIONAL_INFOS":"Additional Infos","MORTGAGE_AMOUNT":"Mortgage Amount","MORTGAGE_VALUE":"Market Value","MORTGAGE_HOLDER":"Mortgage Holder","LANDLORD":"Landlord","PROVINCES":{"ALBERTA":"Alberta","MANITOBA":"Manitoba","BRITISH_COLUMBIA":"British Columbia","NEW_BRUNSWICK":"New Brunswick","NEW_FOUNDLAND":"Newfoundland and Labrador","NOVA_SCOTIA":"Nova Scotia","ONTARIO":"Ontario","PRINCE_EDWARD":"Prince Edward Island","QUEBEC":"Quebec","SASKATCHEWAN":"Saskatchewan"},"ERRORS":{"CURRENT_ADDRESS":"The address is invalid","HOUSING_OPTIONS":"The housing informations are invalid","HOUSING_TYPE":"The home status is invalid","MONTH_COUNT":"The number of months at the address is required","YEAR_COUNT":"The number of years at the address is required"}},"JOINT_INFOS":{"JOINT_APPLICATION":"Joint Application","INCLUDE_COAPPLICANT":"Do you want to include a co-applicant?","YES":"Yes","NO":"No"},"EMPLOYMENT_INFOS":{"WHAT_ABOUT_CURRENT_EMPLOYMENT":"What About Your Current Employment and Income?","EMPLOYMENT_TYPE":"Employment Type","EMPLOYMENT_STATUS":"Employment Status","EMPLOYER":"Employer","YOUR_INCOME":"Your Income","YOUR_WORK":"Your Work","INCOME_FREQUENCY":"Income Frequency","INCOME_AMOUNT":"Amount","OCCUPATION":"Occupation","YEARS_AT_EMPLOYMENT":"Years at Employment","MONTHS_AT_EMPLOYMENT":"Months at Employment","STREET_NUMBER":"Street Number","STREET_NAME":"Street Name","UNIT_NUMBER":"Unit Number","POSTAL_CODE":"Postal Code","CITY":"City","INCOMES":"Incomes","INCOME_GROSS":"Gross Income","PROVINCE":"Province","PHONE_NUMBER":"Phone Number","PHONE_EXTENSION":"Extension","STREET_TYPE":"Street Type","OTHER_INCOME":"Other Income","OTHER_INCOME_FREQUENCY":"Other Income Frequency","NO_OPTION":"No","YES_OPTION":"Yes","EMPLOYMENT_TYPES":{"UNEMPLOYED":"Unemployed","RETIRED":"Retired","EMPLOYED":"Employed","SELF_EMPLOYED":"Self-employed","STUDENT":"Student","OTHER":"Other"},"EMPLOYMENT_STATUSES":{"FULL_TIME":"Full Time","FULL_TIME_PROBATION":"Full Time Probation","PART_TIME_CASUAL":"Part Time Casual","PART_TIME_REGULAR":"Part Time Regular","RETIRED":"Retired","SELF_EMPLOYED":"Self-employed","SEASONAL_SUMMER":"Seasonal Summer","SEASONAL_WINTER":"Seasonal Winter"},"STREET_TYPES":{"ALLEY":"Alley","AVENUE":"Avenue","BOULEVARD":"Boulevard","MOUNT":"Mount","PATH":"Path","PATHWAY":"Pathway","PARKWAY":"Parkway","PLACE":"Place","ROAD":"Road","STREET":"Street","TRAIL":"Trail","WAY":"Way","OTHER":"Other"},"OTHER_INCOME_TYPES":{"CAR_ALLOWANCE":"Car Allowance","CHILD_SUPPORT_ALIMONY":"Child Support/Alimony","DISABILITY_PAYMENTS":"Disability Payments","INVESTMENT_INCOME":"Investment Income","PENSIONS":"Pensions","RENTAL_INCOME":"Rental Income","WORKERS_COMPENSATION":"Workers Compensation","OTHER":"Other"},"INCOME_FREQUENCIES":{"YEARLY":"Yearly","MONTHLY":"Monthly","WEEKLY":"Weekly"},"EMPLOYER_ADDRESS":"Your Employer Address","ERRORS":{"EMPLOYMENT_TYPE":"The employment type is invalid","EMPLOYMENT_STATUS":"The employment status is invalid","EMPLOYMENT_INFOS":"The employment informations are invalid","OTHER_INCOME":"The other income values are invalid"}}}}

/***/ }),

/***/ "./src/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"FINANCING":{"DEPOSIT":{"CONGRATS":"Félicitations!","TITLE":"Votre dépôt de $%{amount} a été complété avec succès.","SUBTITLE":"Poursuivons votre achat."},"APPLICANT_INFO":{"DATE_OF_BIRTH":"Date de naissance","DAY":"Jour","EDIT_PRIMARY_APPLICANT":"Éditez le demandeur principal","EDIT_COAPPLICANT":"Éditez le co-demandeur","FEMALE":"Femme","FIRST_NAME":"Prénom","LAST_NAME":"Nom de famille","PHONE_NUMBER":"Numéro de téléphone","EMAIL":"Courriel","GENDER":"Sexe","MALE":"Homme","MONTH":"Mois","YEAR":"Année","WHO_IS_PRIMARY_APPLICANT":"Qui est le demandeur principal","WHO_IS_COAPPLICANT":"Qui est le co-demandeur","ERRORS":{"IDENTITY":"L'identité est invalide","GENDER":"Le sexe est invalide","DATE_OF_BIRTH":"La date de naissance est invalide"}},"BACK":"Retour","DONE":"Continuez","SUBMIT":"Soumettre mes informations","RESIDENCE_INFOS":{"ADDRESS":{"ADDRESS":"Adresse","ADDRESS2":"Adresse ligne 2","POSTAL_CODE":"Code postal","CITY":"Ville","PROVINCE":"Province"},"MY_CURRENT_ADDRESS":"Mon adresse courante","CURRENT_ADDRESS":"Adresse courante","EDIT_MY_CURRENT_ADDRESS":"Éditer mon adresse courante","EDIT_CURRENT_ADDRESS":"Éditer l'adresse courante","HOME_STATUS":"Votre statut de propriété","HOME_STATUS_TYPE":{"OWN_FREE_AND_CLEAR":"Propriétaire libre d'hypothèque","OWN_MOBILE_HOME":"Proprétaire maison mobile","OTHER":"Autre","OWN_WITH_MORTAGE":"Propriétaire avec hypothèque","PARENTS":"Parents","RENT":"Locataire","RESERVE_HOUSING":"Habitation sur réserve"},"HOUSING":"Habitation","MONTH_COUNT":"Mois à cette adresse","TELL_US_MORE":"Dites-nous en plus à propos de votre résidence","TELL_US_MORE_COAPPLICANT":"Dites-nous en plus à propos de la résidence du co-demandeur","YEAR_COUNT":"Années à cette adresse","MONTHLY_PAYMENTS":"Paiements mensuels","ADDITIONAL_INFOS":"Infos additionnelles","MORTGAGE_AMOUNT":"Montant de l'hypothèque","MORTGAGE_VALUE":"Valeur marchande","MORTGAGE_HOLDER":"Créancier de l'hypothèque","LANDLORD":"Locateur","PROVINCES":{"ALBERTA":"Alberta","MANITOBA":"Manitoba","BRITISH_COLUMBIA":"Colombie Britannique","NEW_BRUNSWICK":"Nouveau-Brunswick","NEW_FOUNDLAND":"Terre-Neuve et Labrador","NOVA_SCOTIA":"Nouvelle-Écosse","ONTARIO":"Ontario","PRINCE_EDWARD":"Île-du-Prince-Édouard","QUEBEC":"Québec","SASKATCHEWAN":"Saskatchewan"},"ERRORS":{"CURRENT_ADDRESS":"L'adresse est invalide","HOUSING_OPTIONS":"Les informations d'habitation sont invalides","HOUSING_TYPE":"Le statut de propriété est invalide","MONTH_COUNT":"Le nombre de mois à l'adresse est requis","YEAR_COUNT":"Le nombre d'années à l'adresse est requis"}},"JOINT_INFOS":{"JOINT_APPLICATION":"Application conjointe","INCLUDE_COAPPLICANT":"Voulez-vous ajouter un co-demandeur?","YES":"Oui","NO":"Non"},"EMPLOYMENT_INFOS":{"WHAT_ABOUT_CURRENT_EMPLOYMENT":"Qu'en est-il de votre emploi actuel et de votre revenu?","EMPLOYMENT_TYPE":"Type d'emploi","EMPLOYMENT_STATUS":"Statut d'emploi","EMPLOYER":"Employeur","YOUR_INCOME":"Votre revenu","YOUR_WORK":"Votre travail","INCOME_FREQUENCY":"Fréquence de revenu","INCOME_AMOUNT":"Montant","OCCUPATION":"Occupation","YEARS_AT_EMPLOYMENT":"Années à l'emploi","MONTHS_AT_EMPLOYMENT":"Mois à l'emploi","STREET_NUMBER":"Numéro civique","STREET_NAME":"Nom de rue","UNIT_NUMBER":"Numéro d'unité","POSTAL_CODE":"Code postal","CITY":"Ville","INCOMES":"Revenus","INCOME_GROSS":"Revenu brut","PROVINCE":"Province","PHONE_NUMBER":"Numéro de téléphone","PHONE_EXTENSION":"Extension","STREET_TYPE":"Type de rue","OTHER_INCOME":"Autres revenus","OTHER_INCOME_FREQUENCY":"Fréquence des autres revenus","NO_OPTION":"Non","YES_OPTION":"Oui","EMPLOYMENT_TYPES":{"UNEMPLOYED":"Sans emploi","RETIRED":"Retraité","EMPLOYED":"Employé","SELF_EMPLOYED":"Travailleur autonome","STUDENT":"Étudiant","OTHER":"Autre"},"EMPLOYMENT_STATUSES":{"FULL_TIME":"Temps plein","FULL_TIME_PROBATION":"Temps plein en probation","PART_TIME_CASUAL":"Temps partiel occasionnel","PART_TIME_REGULAR":"Temps partiel régulier","RETIRED":"Retraité","SELF_EMPLOYED":"Travailleur autonome","SEASONAL_SUMMER":"Saisonnier été","SEASONAL_WINTER":"Saisonnier hiver"},"STREET_TYPES":{"ALLEY":"Ruelle","AVENUE":"Avenue","BOULEVARD":"Boulevard","MOUNT":"Mont","PATH":"Chemin","PATHWAY":"Sentier","PARKWAY":"Route principale","PLACE":"Place","ROAD":"Route","STREET":"Rue","TRAIL":"Piste","WAY":"Voie","OTHER":"Autre"},"OTHER_INCOME_TYPES":{"CAR_ALLOWANCE":"Allocation de voiture","CHILD_SUPPORT_ALIMONY":"Pension alimentaire pour enfants","DISABILITY_PAYMENTS":"Prestations d'invalidité","INVESTMENT_INCOME":"Revenu d'investissements","PENSIONS":"Pensions","RENTAL_INCOME":"Revenus locatifs","WORKERS_COMPENSATION":"Compensations de travailleur","OTHER":"Autre"},"INCOME_FREQUENCIES":{"YEARLY":"Annuel","MONTHLY":"Mensuel","WEEKLY":"Hebdomadaire"},"EMPLOYER_ADDRESS":"L'adresse de votre employeur","ERRORS":{"EMPLOYMENT_TYPE":"Le type d'emploi est invalide","EMPLOYMENT_STATUS":"Le statut d'emploi est invalide","EMPLOYMENT_INFOS":"Les informations d'emploi sont invalides","OTHER_INCOME":"Les valeur de revenus supplémentaires sont invalides"}}}}

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.widgets = undefined;

var _Financing = __webpack_require__("./src/components/Financing/Financing.jsx");

var _Financing2 = _interopRequireDefault(_Financing);

var _FinancingProvider = __webpack_require__("./src/FinancingProvider.jsx");

var _FinancingProvider2 = _interopRequireDefault(_FinancingProvider);

var _DepositState = __webpack_require__("./src/components/DepositState/DepositState.jsx");

var _DepositState2 = _interopRequireDefault(_DepositState);

var _en = __webpack_require__("./src/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = _Financing2.default;
var provider = _FinancingProvider2.default;
var main = provider;

var Translations = {
    en: _en2.default,
    fr: _fr2.default
};

var widgets = exports.widgets = {
    Financing: {
        components: {
            root: root,
            provider: provider,
            main: main,
            DepositState: _DepositState2.default
        },
        Translations: Translations
    }
};

exports.default = {
    root: root,
    provider: provider,
    Financing: main,
    Translations: Translations,
    DepositState: _DepositState2.default
};

/***/ }),

/***/ "./src/providers/redux.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = configureStore;

var _redux = __webpack_require__("../../node_modules/redux/es/index.js");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

/* eslint no-underscore-dangle: 0 */

function configureStore() {
    var rootReducer = (0, _redux.combineReducers)({
        account: _widgetCommonsGeneral.accountReducer
    });

    var $window = _widgetCommonsCoreServices.WindowProxy.get();
    var extension = $window && $window.__REDUX_DEVTOOLS_EXTENSION__ && $window.__REDUX_DEVTOOLS_EXTENSION__();
    var store = (0, _redux.createStore)(rootReducer, extension);

    return store;
}

/***/ }),

/***/ "./src/services/ErrorService/ErrorService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _lodash = __webpack_require__("lodash");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorService = function () {
    function ErrorService() {
        _classCallCheck(this, ErrorService);
    }

    _createClass(ErrorService, [{
        key: 'getErrors',
        value: function getErrors(fieldValidations, localePrefix) {
            var errors = [];
            (0, _lodash.forOwn)(fieldValidations, function (isValid, key) {
                if (!isValid) {
                    errors.push({
                        code: 'error.' + key,
                        message: _widgetCommonsCoreServices.LocaleService.t(localePrefix + '.' + (0, _lodash.toUpper)((0, _lodash.snakeCase)(key)))
                    });
                }
            });

            return errors;
        }
    }]);

    return ErrorService;
}();

exports.default = new ErrorService();

/***/ }),

/***/ "./src/services/FinancingMapperService/FinancingMapperService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FinancingMapperService = function () {
    function FinancingMapperService() {
        _classCallCheck(this, FinancingMapperService);
    }

    _createClass(FinancingMapperService, [{
        key: 'getFinancingApplicationFromState',
        value: function getFinancingApplicationFromState(_ref) {
            var primaryApplicant = _ref.primaryApplicant,
                coApplicant = _ref.coApplicant,
                hasCoApplicant = _ref.hasCoApplicant;

            var financingApplication = {
                financing: {
                    CreditAppType: 'FCA',
                    PrimaryApplicant: this.mapApplicant(primaryApplicant),
                    CoApplicant: hasCoApplicant ? this.mapApplicant(coApplicant) : null
                }
            };

            return financingApplication;
        }
    }, {
        key: 'mapAddress',
        value: function mapAddress(_ref2) {
            var address = _ref2.address,
                monthCount = _ref2.monthCount,
                yearCount = _ref2.yearCount;

            if (address) {
                return {
                    StreetNo: address.address ? address.address.substr(0, address.address.indexOf(' ')) : '',
                    StreetName: address.address ? address.address.substr(address.address.indexOf(' ') + 1) : '',
                    SuiteNo: address.address2,
                    PostalCode: address.postalCode,
                    City: address.city,
                    Province: 'CA-' + address.province,
                    YearsAtAddress: yearCount,
                    MonthsAtAddress: monthCount,
                    StreetType: null,
                    AddressType: 'ST'
                };
            }
            return {};
        }
    }, {
        key: 'mapApplicant',
        value: function mapApplicant(_ref3) {
            var personalInformations = _ref3.personalInformations,
                residenceInformations = _ref3.residenceInformations,
                employmentInformations = _ref3.employmentInformations;

            return _extends({
                GenderId: personalInformations.gender,
                FirstName: personalInformations.firstname,
                LastName: personalInformations.lastname,
                DateOfBirth: personalInformations.monthOfBirth + '-' + personalInformations.dayOfBirth + '-' + personalInformations.yearOfBirth,
                Phone: personalInformations.phoneNumber,
                Email: personalInformations.email
            }, this.mapIncome(employmentInformations), {
                CurrentAddress: this.mapAddress(residenceInformations),
                HomeOwnershipType: (0, _lodash.startCase)(residenceInformations.housingType),
                CurrentEmployment: this.mapEmployment(employmentInformations)
            }, this.mapMortgage(residenceInformations));
        }
    }, {
        key: 'mapMortgage',
        value: function mapMortgage(_ref4) {
            var housingValues = _ref4.housingValues;

            if (housingValues) {
                return {
                    HomeMortgageOwnership: housingValues.mortgageHolder,
                    HomeMonthlyPayment: housingValues.monthlypayments,
                    HomeMarketValue: housingValues.mortgageValue,
                    HomeMortgageAmount: housingValues.mortgageAmount
                };
            }
            return {};
        }
    }, {
        key: 'mapEmployment',
        value: function mapEmployment(employmentInformations) {
            return {
                EmploymentStatus: employmentInformations.status,
                EmploymentType: employmentInformations.type,
                EmployerName: employmentInformations.employer,
                Occupation: employmentInformations.occupation,
                EmployerPhone: employmentInformations.phoneNumber,
                EmployerPhoneExt: employmentInformations.phoneExtension,
                EmployerDurationYears: employmentInformations.yearsAtEmployment,
                EmployerDurationMonths: employmentInformations.monthsAtEmployment,
                Address: {
                    Province: 'CA-' + employmentInformations.province,
                    AddressType: null,
                    StreetNo: employmentInformations.streetNumber,
                    StreetName: employmentInformations.streetName,
                    StreetType: employmentInformations.streetType,
                    StreetDirection: null,
                    SuiteNo: employmentInformations.unitNumber,
                    City: employmentInformations.city,
                    PostalCode: employmentInformations.postalCode
                }
            };
        }
    }, {
        key: 'mapIncome',
        value: function mapIncome(_ref5) {
            var incomeGross = _ref5.incomeGross,
                incomes = _ref5.incomes,
                otherIncome = _ref5.otherIncome;

            return _extends({
                IncomeGross: incomeGross,
                IncomeGrossBasis: incomes
            }, this.mapOtherIncome(otherIncome));
        }
    }, {
        key: 'mapOtherIncome',
        value: function mapOtherIncome(otherIncome) {
            if (otherIncome) {
                return {
                    OtherIncomeType: otherIncome.type,
                    IncomeOther: otherIncome.amount,
                    IncomeOtherBasis: otherIncome.frequency,
                    IncomeOtherDescription: ''
                };
            }
            return {};
        }
    }]);

    return FinancingMapperService;
}();

exports.default = new FinancingMapperService();

/***/ }),

/***/ "./src/services/FinancingService/FinancingService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _lodash = __webpack_require__("lodash");

var _loggerSentry = __webpack_require__("../../node_modules/@sm360/logger-sentry/dist/index.js");

var _loggerSentry2 = _interopRequireDefault(_loggerSentry);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Service to interact with Financing
 */
var FinancingService = function () {
    function FinancingService() {
        _classCallCheck(this, FinancingService);

        this.basePath = _index2.default.endpoint.widget + '/widgets/financing';
        this.logger = new _loggerSentry2.default('FinancingService', _widgetCommonsCoreServices.ConfigsService.getLoggerContext());
    }

    _createClass(FinancingService, [{
        key: '_callSaveFinancing',
        value: function _callSaveFinancing() {
            var trackedPageCookie = _widgetCommonsGeneral.CookieService.getToken('primary-tracked-page');
            var adgearUidCookie = _widgetCommonsGeneral.CookieService.getToken('aguid');
            var authTokenCookie = _widgetCommonsGeneral.CookieService.getToken('auth-token');

            var trackedPage = {};
            if (trackedPageCookie) {
                try {
                    trackedPage.primaryTrackedPage = JSON.parse(trackedPageCookie.replace(/\\/g, ''));
                } catch (e) {
                    this.logger.error('Failed to parse to JSON the following cookie "' + trackedPageCookie + '"', e);
                }
            }

            if (adgearUidCookie) {
                trackedPage.adgearUid = adgearUidCookie;
            }

            if (authTokenCookie) {
                trackedPage.token = authTokenCookie;
            }

            return trackedPage;
        }

        /**
         * Will *create* a financing with the given information
         * @deprecated
         *
         * @param {any} financing The financing object to create
         * @param {any} leadId The id of the lead to update. Must be an integer
         * @returns {Promise} The result data in a promise
         * @memberof FinancingService
         */

    }, {
        key: 'createFinancing',
        value: function createFinancing(financing, leadId) {
            var _this = this;

            return new Promise(function (resolve, reject) {
                if (!(0, _lodash.isObjectLike)(financing) || !(0, _lodash.isSafeInteger)(leadId)) {
                    return reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('invalidParams', {
                        status: 400
                    }));
                }

                var trackedPage = _this._callSaveFinancing();

                return _axios2.default.post(_this.basePath, _extends({}, financing, trackedPage, {
                    leadId: leadId
                }));
            });
        }

        /**
         * Will save the financing information
         *
         * @param {any} financing The financing object to create
         * @returns {Promise} The result data in a promise
         * @memberof FinancingService
         */

    }, {
        key: 'saveFinancing',
        value: function saveFinancing(financing, leadId) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                if (!(0, _lodash.isObjectLike)(financing)) {
                    return reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('invalidParams', {
                        status: 400
                    }));
                }

                var trackedPage = _this2._callSaveFinancing();
                var websiteId = _widgetCommonsCoreServices.ConfigsService.getWebsiteId();

                return resolve(_axios2.default.put(_this2.basePath, _extends({}, financing, trackedPage, {
                    websiteId: websiteId,
                    leadId: leadId
                })));
            });
        }
    }]);

    return FinancingService;
}();

exports.default = new FinancingService();

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/index.js");


/***/ }),

/***/ "@sm360/widget-commons-core-services":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_core_services__;

/***/ }),

/***/ "@sm360/widget-commons-forms":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_forms__;

/***/ }),

/***/ "@sm360/widget-commons-general":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__;

/***/ }),

/***/ "@sm360/widget-commons-vehicle":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_vehicle__;

/***/ }),

/***/ "lodash":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_lodash__;

/***/ }),

/***/ "moment":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_moment__;

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// widget-6.25.3.min.js